// Import centralized date utilities
import { formatDateForDisplay, formatDateForDisplayArabic } from './dateUtils';
import { kvGet } from '../infrastructure/storage/kvAccess';
import { readActiveCurrencyType, toDisplayAmount } from './posCurrencyUtils';
import { managerDashboardFr, managerDashboardAr } from './i18n/managerDashboard';
import { workerSessionManagerFr, workerSessionManagerAr } from './i18n/workerSessionManager';
import { paymentReportPageFr, paymentReportPageAr } from './i18n/paymentReportPage';
import { stockPageFr, stockPageAr } from './i18n/stockPage';
import { catalogPageFr, catalogPageAr } from './i18n/catalogPage';
import { settingsPageFr, settingsPageAr } from './i18n/settingsPage';
import { employeesPageFr, employeesPageAr } from './i18n/employeesPage';
import { inventoryPageFr, inventoryPageAr } from './i18n/inventoryPage';
import { priceLabelsFr, priceLabelsAr } from './i18n/priceLabels';
import { addProductModalFr, addProductModalAr } from './i18n/addProductModal';
import { addOrderModalFr, addOrderModalAr } from './i18n/addOrderModal';
import { addPurchaseModalFr, addPurchaseModalAr } from './i18n/addPurchaseModal';
import { editProductModalFr, editProductModalAr } from './i18n/editProductModal';
import { orderConfirmationModalFr, orderConfirmationModalAr } from './i18n/orderConfirmationModal';
import { achatVsVenteReportFr, achatVsVenteReportAr } from './i18n/achatVsVenteReport';
import { foodCostReportFr, foodCostReportAr } from './i18n/foodCostReport';
import { adminDashboardFr, adminDashboardAr } from './i18n/adminDashboard';
import { registerPageFr, registerPageAr } from './i18n/registerPage';
import { authPageLoginFr, authPageLoginAr } from './i18n/authPageLogin';
import { productValidationModalFr, productValidationModalAr } from './i18n/productValidationModal';
import { codeEntryModalFr, codeEntryModalAr } from './i18n/codeEntryModal';
import { salesDetailsModalFr, salesDetailsModalAr } from './i18n/salesDetailsModal';
import { editOrderModalFr, editOrderModalAr } from './i18n/editOrderModal';
import { dashboardReceiptModalFr, dashboardReceiptModalAr } from './i18n/dashboardReceiptModal';
import { ordersExcelImportModalFr, ordersExcelImportModalAr } from './i18n/ordersExcelImportModal';
import { posDashboardFr, posDashboardAr } from './i18n/posDashboard';
import { smartInvoiceDisplayFr, smartInvoiceDisplayAr } from './i18n/smartInvoiceDisplay';
import { lotSelectionModalFr, lotSelectionModalAr } from './i18n/lotSelectionModal';
import { editPurchaseModalFr, editPurchaseModalAr } from './i18n/editPurchaseModal';
import { layoutShellFr, layoutShellAr } from './i18n/layoutShell';
import { addCustomerModalFr, addCustomerModalAr } from './i18n/addCustomerModal';
import { draftsModalFr, draftsModalAr } from './i18n/draftsModal';
import { fastImportModalFr, fastImportModalAr } from './i18n/fastImportModal';
import { addSupplierModalFr, addSupplierModalAr } from './i18n/addSupplierModal';
import { datePickerFr, datePickerAr } from './i18n/datePicker';
import { excelImportModalFr, excelImportModalAr } from './i18n/excelImportModal';
import { paymentManagementPageFr, paymentManagementPageAr } from './i18n/paymentManagementPage';
import { orderDetailsModalFr, orderDetailsModalAr } from './i18n/orderDetailsModal';
import { exportPrintButtonFr, exportPrintButtonAr } from './i18n/exportPrintButton';
import { virtualizedProductRowFr, virtualizedProductRowAr } from './i18n/virtualizedProductRow';
import { merchantReceiptModalFr, merchantReceiptModalAr } from './i18n/merchantReceiptModal';
import { confirmDialogFr, confirmDialogAr } from './i18n/confirmDialog';
import { ecartModalFr, ecartModalAr } from './i18n/ecartModal';
import { dailyClosingHistoryModalFr, dailyClosingHistoryModalAr } from './i18n/dailyClosingHistoryModal';
import { periodClosingHistoryModalFr, periodClosingHistoryModalAr } from './i18n/periodClosingHistoryModal';
import { loadingOverlayFr, loadingOverlayAr } from './i18n/loadingOverlay';
import { notificationCenterFr, notificationCenterAr } from './i18n/notificationCenter';
import { newCashRegisterModalFr, newCashRegisterModalAr } from './i18n/newCashRegisterModal';
import { workerDashboardModalFr, workerDashboardModalAr } from './i18n/workerDashboardModal';
import { excelImportAchatModalFr, excelImportAchatModalAr } from './i18n/excelImportAchatModal';
import { barcodeScannerFr, barcodeScannerAr } from './i18n/barcodeScanner';
import { languageSwitcherFr, languageSwitcherAr } from './i18n/languageSwitcher';
import { offlineIndicatorFr, offlineIndicatorAr } from './i18n/offlineIndicator';
import { storageSafeModeBannerFr, storageSafeModeBannerAr, inventoryLedgerSafeModeFr, inventoryLedgerSafeModeAr } from './i18n/storageSafeModeBanner';
import { conditionalRoutesFr, conditionalRoutesAr } from './i18n/conditionalRoutes';
import { storageBootstrapFr, storageBootstrapAr } from './i18n/storageBootstrap';
import { tableCommonFr, tableCommonAr } from './i18n/tableCommon';
import { pharmacyLotManagerFr, pharmacyLotManagerAr } from './i18n/pharmacyLotManager';
import { printServicePageFr, printServicePageAr } from './i18n/printServicePage';
import { barcodeAutoLinkModalFr, barcodeAutoLinkModalAr } from './i18n/barcodeAutoLinkModal';
import { restaurantPageFr, restaurantPageAr } from './i18n/restaurantPage';
import { cuisinePageFr, cuisinePageAr } from './i18n/cuisinePage';
import { pharmacyDashboardFr, pharmacyDashboardAr } from './i18n/pharmacyDashboard';
import { paymentModalFr, paymentModalAr } from './i18n/paymentModal';
import { invoiceManagementModalFr, invoiceManagementModalAr } from './i18n/invoiceManagementModal';

import {
  CATEGORY_KEYS,
  SUBCATEGORY_KEYS,
  categories,
  businessTypes,
  BUSINESS_TYPE_CONFIG,
  getSubcategoriesForCategory,
  getTypesForSubcategory,
  getCategoriesForBusinessType,
  getCategoryOptionsForBusinessType,
  getCategoryLabel,
  getSubcategoryLabel,
  getTypeLabel,
  resolveCategoryDisplay,
  getBusinessTypeLabel,
  getTranslatedLabel,
  listBusinessTypes,
  isCategoryAllowedForBusiness,
  canonicalizeCategoryKey,
  assertCatalogIntegrity,
} from '../catalog';

export {
  CATEGORY_KEYS,
  SUBCATEGORY_KEYS,
  categories,
  businessTypes,
  BUSINESS_TYPE_CONFIG,
  getSubcategoriesForCategory,
  getTypesForSubcategory,
  getCategoriesForBusinessType,
  getCategoryOptionsForBusinessType,
  getCategoryLabel,
  getSubcategoryLabel,
  getTypeLabel,
  resolveCategoryDisplay,
  getBusinessTypeLabel,
  getTranslatedLabel,
  listBusinessTypes,
  isCategoryAllowedForBusiness,
  canonicalizeCategoryKey,
  assertCatalogIntegrity,
};


/** @returns {'MRO'|'MRU'} */
function readStoredAppCurrency() {
  return readActiveCurrencyType();
}

export const unitOptions = ['unit', 'kg', 'g', 'l', 'ml', 'pcs', 'box', 'carton', 'pack'];

// Navigation Labels
export const navigationLabels = {
  dashboard: { name: 'Tableau de bord', nameAr: 'لوحة التحكم' },
  inventory: { name: 'Produits', nameAr: 'المنتجات' },
  stock: { name: 'Gestion des Stocks', nameAr: 'المخزون' },
  sales: { name: 'Ventes', nameAr: 'المبيعات' },
  purchases: { name: 'Achats', nameAr: 'المشتريات' },
  orders: { name: 'Commandes', nameAr: 'الطلبات' },
  suppliers: { name: 'Fournisseurs', nameAr: 'الموردين' },
  customers: { name: 'Clients', nameAr: 'العملاء' },
  reports: { name: 'Rapports', nameAr: 'التقارير' },
  payments: { name: 'Paiement Factures', nameAr: 'دفع الفواتير' },
  settings: { name: 'Paramètres', nameAr: 'الإعدادات' },
  logout: { name: 'Déconnexion', nameAr: 'تسجيل الخروج' }
};

// Form Labels
export const formLabels = {
  name: { name: 'Nom', nameAr: 'الاسم' },
  email: { name: 'Email', nameAr: 'البريد الإلكتروني' },
  phone: { name: 'Téléphone', nameAr: 'الهاتف' },
  address: { name: 'Adresse', nameAr: 'العنوان' },
  quantity: { name: 'Quantité', nameAr: 'الكمية' },
  price: { name: 'Prix', nameAr: 'السعر' },
  total: { name: 'Total', nameAr: 'المجموع' },
  date: { name: 'Date', nameAr: 'التاريخ' },
  status: { name: 'Statut', nameAr: 'الحالة' },
  category: { name: 'Catégorie', nameAr: 'الفئة' },
  subcategory: { name: 'Sous-catégorie', nameAr: 'الفئة الفرعية' },
  type: { name: 'Type', nameAr: 'النوع' },
  supplier: { name: 'Fournisseur', nameAr: 'المورد' },
  customer: { name: 'Client', nameAr: 'العميل' },
  product: { name: 'Produit', nameAr: 'المنتج' },
  description: { name: 'Description', nameAr: 'الوصف' },
  notes: { name: 'Notes', nameAr: 'ملاحظات' },
  unit: { name: 'Unité', nameAr: 'الوحدة' },
  sku: { name: 'SKU', nameAr: 'رمز المنتج' },
  value: { name: 'Valeur', nameAr: 'القيمة' },
  actions: { name: 'Actions', nameAr: 'الإجراءات' }
};

// Units with translations
export const units = {
  kg: { name: 'kg', nameAr: 'كجم' },
  g: { name: 'g', nameAr: 'جم' },
  l: { name: 'l', nameAr: 'لتر' },
  ml: { name: 'ml', nameAr: 'مل' },
  cl: { name: 'cl', nameAr: 'سنتيلتر' },
  gal: { name: 'gal', nameAr: 'غالون' },
  pcs: { name: 'pièce', nameAr: 'قطعة' },
  unit: { name: 'unité', nameAr: 'وحدة' },
  box: { name: 'boîte', nameAr: 'علبة' },
  carton: { name: 'carton', nameAr: 'كرتونة' },
  pack: { name: 'pack', nameAr: 'عبوة' },
  lb: { name: 'lb', nameAr: 'باوند' },
  oz: { name: 'oz', nameAr: 'أونصة' }
};

// Locations with translations
export const locations = {
  'Principal': { name: 'Principal', nameAr: 'الرئيسي' },
  'Entrepôt': { name: 'Entrepôt', nameAr: 'المستودع' },
  'Magasin': { name: 'Magasin', nameAr: 'المتجر' },
  'Réfrigérateur': { name: 'Réfrigérateur', nameAr: 'الثلاجة' },
  'Congélateur': { name: 'Congélateur', nameAr: 'المجمد' },
  'Étagère': { name: 'Étagère', nameAr: 'الرف' },
  'Vitrine': { name: 'Vitrine', nameAr: 'الواجهة' }
};

// Pharmacy Storage Types
export const PHARMACY_STORAGE_TYPES = {
  REFRIGERATED: 'refrigerated',
  CONTROLLED_ROOM_TEMP: 'controlled_room_temp',
  FROZEN: 'frozen',
  AMBIENT: 'ambient',
  PROTECTED_LIGHT: 'protected_light',
  CONTROLLED_HUMIDITY: 'controlled_humidity'
};

// Pharmacy Storage Requirements
export const PHARMACY_STORAGE_REQUIREMENTS = {
  [PHARMACY_STORAGE_TYPES.REFRIGERATED]: {
    name: 'Réfrigéré',
    nameAr: 'مبرد',
    temperature: '2-8°C',
    description: 'Médicaments nécessitant une réfrigération',
    icon: '❄️',
    tone: 'info',
    color: 'var(--ads-color-info)'
  },
  [PHARMACY_STORAGE_TYPES.CONTROLLED_ROOM_TEMP]: {
    name: 'Température Contrôlée',
    nameAr: 'درجة حرارة محكومة',
    temperature: '15-25°C',
    description: 'Médicaments à température contrôlée',
    icon: '🌡️',
    tone: 'success',
    color: 'var(--ads-color-success)'
  },
  [PHARMACY_STORAGE_TYPES.FROZEN]: {
    name: 'Congelé',
    nameAr: 'مجمدة',
    temperature: '-20°C',
    description: 'Médicaments nécessitant une congélation',
    icon: '🧊',
    tone: 'info',
    color: 'var(--ads-color-info-dark)'
  },
  [PHARMACY_STORAGE_TYPES.AMBIENT]: {
    name: 'Température Ambiante',
    nameAr: 'درجة حرارة الغرفة',
    temperature: '15-30°C',
    description: 'Médicaments à température ambiante',
    icon: '🏠',
    tone: 'warning',
    color: 'var(--ads-color-warning)'
  },
  [PHARMACY_STORAGE_TYPES.PROTECTED_LIGHT]: {
    name: 'Protégé de la Lumière',
    nameAr: 'محمي من الضوء',
    temperature: '15-25°C',
    description: 'Médicaments sensibles à la lumière',
    icon: '🌙',
    tone: 'accent',
    color: 'var(--ads-color-primary-active)'
  },
  [PHARMACY_STORAGE_TYPES.CONTROLLED_HUMIDITY]: {
    name: 'Humidité Contrôlée',
    nameAr: 'رطوبة محكومة',
    temperature: '15-25°C',
    description: 'Médicaments sensibles à l\'humidité',
    icon: '💧',
    tone: 'primary',
    color: 'var(--ads-color-primary)'
  }
};

/** Nom d'affichage du type de stockage pharmacie selon la langue UI. */
export const getPharmacyStorageDisplayName = (storageType, isRTL = false) => {
  const info = PHARMACY_STORAGE_REQUIREMENTS[storageType];
  if (!info) return '';
  return isRTL ? info.nameAr : info.name;
};

// Pharmacy-specific helper functions
export const getPharmacyStorageRequirement = (medicationType) => {
  const storageMap = {
    // Médicaments réfrigérés
    'Insuline': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    'Vaccins': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    'Sérum': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    'Morphine': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    'Codéine': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    'Hormones': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    'Facteurs de Coagulation': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    'Immunoglobulines': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    'Interféron': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    'Interleukine': PHARMACY_STORAGE_TYPES.REFRIGERATED,
    
    // Médicaments congelés
    'Vaccins Congelés': PHARMACY_STORAGE_TYPES.FROZEN,
    'Sérum Congelé': PHARMACY_STORAGE_TYPES.FROZEN,
    'Facteurs de Coagulation Congelés': PHARMACY_STORAGE_TYPES.FROZEN,
    
    // Médicaments protégés de la lumière
    'Nitroglycérine': PHARMACY_STORAGE_TYPES.PROTECTED_LIGHT,
    'Dopamine': PHARMACY_STORAGE_TYPES.PROTECTED_LIGHT,
    'Adrénaline': PHARMACY_STORAGE_TYPES.PROTECTED_LIGHT,
    'Noradrénaline': PHARMACY_STORAGE_TYPES.PROTECTED_LIGHT,
    'Dobutamine': PHARMACY_STORAGE_TYPES.PROTECTED_LIGHT,
    
    // Médicaments à humidité contrôlée
    'Comprimés Effervescents': PHARMACY_STORAGE_TYPES.CONTROLLED_HUMIDITY,
    'Capsules Molles': PHARMACY_STORAGE_TYPES.CONTROLLED_HUMIDITY,
    'Poudres Médicamenteuses': PHARMACY_STORAGE_TYPES.CONTROLLED_HUMIDITY,
    
    // Médicaments à température contrôlée
    'Antibiotiques': PHARMACY_STORAGE_TYPES.CONTROLLED_ROOM_TEMP,
    'Vitamines': PHARMACY_STORAGE_TYPES.CONTROLLED_ROOM_TEMP,
    'Compléments Alimentaires': PHARMACY_STORAGE_TYPES.CONTROLLED_ROOM_TEMP,
    'Médicaments Prescrits': PHARMACY_STORAGE_TYPES.CONTROLLED_ROOM_TEMP,
    'Médicaments en Vente Libre': PHARMACY_STORAGE_TYPES.CONTROLLED_ROOM_TEMP,
    
    // Médicaments à température ambiante (par défaut)
    'Antalgiques': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Antihistaminiques': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Anti-inflammatoires': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Antispasmodiques': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Antidépresseurs': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Anticoagulants': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Antidiabétiques': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Antihypertenseurs': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Bronchodilatateurs': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Corticoïdes': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Diurétiques': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Laxatifs': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Antiacides': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Antifongiques': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Antiviraux': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Paracétamol': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Ibuprofène': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Aspirine': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Doliprane': PHARMACY_STORAGE_TYPES.AMBIENT,
    'Efferalgan': PHARMACY_STORAGE_TYPES.AMBIENT
  };
  
  return storageMap[medicationType] || PHARMACY_STORAGE_TYPES.AMBIENT;
};

export const getPharmacyStorageInfo = (medicationType) => {
  const storageType = getPharmacyStorageRequirement(medicationType);
  return PHARMACY_STORAGE_REQUIREMENTS[storageType];
};

// Pharmacy-specific stock locations
export const PHARMACY_STOCK_LOCATIONS = {
  REFRIGERATOR_1: 'Réfrigérateur Principal',
  REFRIGERATOR_2: 'Réfrigérateur Secondaire',
  FREEZER_1: 'Congélateur Principal',
  FREEZER_2: 'Congélateur Secondaire',
  CONTROLLED_ROOM: 'Salle Température Contrôlée',
  AMBIENT_ROOM: 'Salle Température Ambiante',
  PROTECTED_SHELF: 'Étagère Protégée Lumière',
  HUMIDITY_CONTROLLED: 'Armoire Humidité Contrôlée',
  MAIN_STORAGE: 'Stockage Principal',
  EMERGENCY_STORAGE: 'Stockage d\'Urgence'
};

// Default stock locations for pharmacy business
export const getDefaultPharmacyStockLocations = () => [
  PHARMACY_STOCK_LOCATIONS.MAIN_STORAGE,
  PHARMACY_STOCK_LOCATIONS.REFRIGERATOR_1,
  PHARMACY_STOCK_LOCATIONS.FREEZER_1,
  PHARMACY_STOCK_LOCATIONS.CONTROLLED_ROOM,
  PHARMACY_STOCK_LOCATIONS.AMBIENT_ROOM,
  PHARMACY_STOCK_LOCATIONS.PROTECTED_SHELF,
  PHARMACY_STOCK_LOCATIONS.HUMIDITY_CONTROLLED,
  PHARMACY_STOCK_LOCATIONS.EMERGENCY_STORAGE
];

// Utility functions for number formatting with Arabic numerals
export const formatNumber = (number, locale = 'fr-MR') => {
  const numericValue = typeof number === 'number' ? number : parseFloat(number);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;

  let formatted = safeValue.toLocaleString(locale, {
    numberingSystem: locale.startsWith('ar') ? 'latn' : undefined
  });
  
  // FIX: Replace unwanted "/" with "." for thousand separator
  // Some locales use "/" as thousand separator, but we want "." (e.g., 16.420 instead of 16/420)
  formatted = String(formatted).replace(/(\d)\/(\d{3})/g, '$1.$2'); // Replace pattern like "16/420" with "16.420"
  formatted = String(formatted).replace(/(\d)\/(\d)/g, '$1.$2'); // Replace any remaining "/" between digits with "."
  
  return formatted;
};

export const formatCurrency = (amount, locale = 'fr-MR', currency = null) => {
  // Handle NaN, null, undefined, or invalid amounts
  if (amount === null || amount === undefined || isNaN(amount) || amount === '') {
    amount = 0;
  }
  
  // Convert to number if it's a string
  const numericAmount = parseFloat(amount);
  if (isNaN(numericAmount)) {
    amount = 0;
  } else {
    amount = numericAmount;
  }

  const targetCurrency = currency || readActiveCurrencyType();
  const displayAmount = toDisplayAmount(amount, targetCurrency);

  // Format with proper currency symbol
  let formattedAmount = new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    numberingSystem: locale.startsWith('ar') ? 'latn' : undefined
  }).format(displayAmount);

  // FIX: Replace unwanted "/" with "." for thousand separator
  // Some locales use "/" as thousand separator, but we want "." (e.g., 16.420,00 instead of 16/420,00)
  formattedAmount = formattedAmount.replace(/(\d)\/(\d{3})/g, '$1.$2'); // Replace pattern like "16/420" with "16.420"
  formattedAmount = formattedAmount.replace(/(\d)\/(\d)/g, '$1.$2'); // Replace any remaining "/" between digits with "."

  // Add currency symbol
  return `${formattedAmount} ${targetCurrency}`;
};

// New function that formats currency with custom currency names
export const formatCurrencyWithName = (amount, locale = 'fr-MR', currencyName = null) => {
  // Handle NaN, null, undefined, or invalid amounts
  if (amount === null || amount === undefined || isNaN(amount) || amount === '') {
    amount = 0;
  }
  
  // Convert to number if it's a string
  const numericAmount = parseFloat(amount);
  if (isNaN(numericAmount)) {
    amount = 0;
  } else {
    amount = numericAmount;
  }

  const targetCurrency = readActiveCurrencyType();
  const displayAmount = toDisplayAmount(amount, targetCurrency);

  // Format the amount without currency symbol
  let formattedAmount = new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    numberingSystem: locale.startsWith('ar') ? 'latn' : undefined
  }).format(displayAmount);

  // FIX: Replace unwanted "/" with "." for thousand separator
  // Some locales use "/" as thousand separator, but we want "." (e.g., 16.420,00 instead of 16/420,00)
  formattedAmount = formattedAmount.replace(/(\d)\/(\d{3})/g, '$1.$2'); // Replace pattern like "16/420" with "16.420"
  formattedAmount = formattedAmount.replace(/(\d)\/(\d)/g, '$1.$2'); // Replace any remaining "/" between digits with "."

  // Custom label: keep amount→currency in reading order per locale.
  // FR: LRI (LTR isolate). AR: RLI (RTL isolate) so amount is read first (right side).
  if (currencyName) {
    const isolateStart = locale.startsWith('ar') ? '\u2067' : '\u2066';
    return `${isolateStart}${formattedAmount}\u00A0${currencyName}\u2069`;
  } else {
    let currencyFormatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: targetCurrency,
      numberingSystem: locale.startsWith('ar') ? 'latn' : undefined
    }).format(displayAmount);
    
    // FIX: Also fix currency format if it has "/"
    currencyFormatted = currencyFormatted.replace(/(\d)\/(\d{3})/g, '$1.$2');
    currencyFormatted = currencyFormatted.replace(/(\d)\/(\d)/g, '$1.$2');
    
    const isolateStart = locale.startsWith('ar') ? '\u2067' : '\u2066';
    return `${isolateStart}${currencyFormatted}\u2069`;
  }
};

export const formatDate = (date, locale = 'fr-MR', options = {}) => {
  if (!date) return '';
  
  try {
    if (locale.startsWith('ar')) {
      return formatDateForDisplayArabic(date, options);
    } else {
      return formatDateForDisplay(date, options);
    }
  } catch (error) {
    console.warn('Date formatting error:', error, 'Date:', date, 'Locale:', locale);
    return '';
  }
}; 

// Common form validation functions
export const validateRequired = (value, fieldName) => {
  if (!value || value.trim() === '') {
    return `${fieldName} est requis`;
  }
  return null;
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Email invalide';
  }
  return null;
};

export const validatePhone = (phone) => {
  const phoneRegex = /^[+]?[0-9\s\-()]{8,}$/;
  if (!phoneRegex.test(phone)) {
    return 'Numéro de téléphone invalide';
  }
  return null;
};

// Common form field components
export const FormField = ({ label, children, required = false, error = null }) => (
  <div className="form-group">
    <label>
      {label} {required && '*'}
    </label>
    {children}
    {error && <div className="error-message">{error}</div>}
  </div>
);

// Common button components — class aliases to ADS (no React AdsButton import in constants bag)
export const PrimaryButton = ({ children, onClick, disabled = false, type = 'button' }) => (
  <button
    type={type}
    className="ads-button ads-button--primary"
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export const SecondaryButton = ({ children, onClick, disabled = false, type = 'button' }) => (
  <button
    type={type}
    className="ads-button ads-button--secondary"
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

// Common table components
export const TableHeader = ({ children }) => <th>{children}</th>;
export const TableCell = ({ children, className = '' }) => <td className={className}>{children}</td>;

// Common modal components
export const ModalHeader = ({ title, onClose }) => (
  <div className="modal-header">
    <h2>{title}</h2>
    <button className="modal-close" onClick={onClose}>×</button>
  </div>
);

export const ModalFooter = ({ children }) => (
  <div className="modal-footer">
    {children}
  </div>
);

/**
 * Get translated navigation label
 * @param {string} key - Navigation key
 * @param {string} language - Language code ('fr' or 'ar')
 * @returns {string} Translated navigation label
 */
export const getNavigationLabel = (key, language = 'fr') => {
  return getTranslatedLabel(navigationLabels, key, language);
};

/**
 * Get translated form label
 * @param {string} key - Form field key
 * @param {string} language - Language code ('fr' or 'ar')
 * @returns {string} Translated form label
 */
export const getFormLabel = (key, language = 'fr') => {
  return getTranslatedLabel(formLabels, key, language);
};

/**
 * Get translated unit name
 * @param {string} key - Unit key
 * @param {string} language - Language code ('fr' or 'ar')
 * @returns {string} Translated unit name
 */
export const getUnitLabel = (key, language = 'fr') => {
  return getTranslatedLabel(units, key, language);
};

/**
 * Get translated location name
 * @param {string} key - Location key
 * @param {string} language - Language code ('fr' or 'ar')
 * @returns {string} Translated location name
 */
export const getLocationLabel = (key, language = 'fr') => {
  return getTranslatedLabel(locations, key, language);
};

// Legacy function aliases for backward compatibility
export const getTranslatedCategory = getCategoryLabel;
export const getTranslatedSubcategory = getSubcategoryLabel;
export const getTranslatedType = getTypeLabel;
export const getTranslatedUnit = getUnitLabel;
export const getTranslatedLocation = getLocationLabel;

// ============================================================================
// UI TRANSLATIONS - Consolidated from translations.js
// ============================================================================

export const translations = {
  fr: {
    // Navigation
    dashboard: 'Tableau de bord',
    inventory: 'Produits',
    stock: 'Gestion des Stocks',
    stockWrite: 'Stocks — modifier (transfert, lots)',
    sales: 'Ventes',
    voidSales: 'Ventes — storno (annuler)',
    purchases: 'Achats',
    orders: 'Commandes',
    suppliers: 'Fournisseurs',
    customers: 'Clients',
    reports: 'Rapports',
    payments: 'Paiement Factures',
    settings: 'Paramètres',
    logout: 'Déconnexion',

    // Common Actions
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    search: 'Rechercher',
    filter: 'Filtrer',
    export: 'Exporter',
    import: 'Importer',
    view: 'Voir',
    update: 'Mettre à jour',
    create: 'Créer',
    remove: 'Retirer',
    select: 'Sélectionner',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    reset: 'Réinitialiser',
    clear: 'Effacer',
    pay: 'Payer',
    autoUpdate: 'Mise à jour automatique',
    openCalendar: 'Ouvrir le calendrier',
    previousMonth: 'Mois précédent',
    nextMonth: 'Mois suivant',
    datePlaceholder: 'JJ/MM/AAAA',
    invalidDate: 'Date invalide',
    dateBeforeMinimum: 'Date antérieure au minimum',
    dateAfterMaximum: 'Date postérieure au maximum',
    credit: 'Crédit',
    noInvoicesFound: 'Aucune facture trouvée',
    createInvoices: 'Créer des factures',
    addPayment: 'Ajouter un paiement',
    amount: 'Montant',

    // Form Labels
    name: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    address: 'Adresse',
    quantity: 'Quantité',
    price: 'Prix',
    total: 'Total',
    date: 'Date',
    status: 'Statut',
    for: 'pour',
    order: 'commande',
    purchase: 'achat',
    category: 'Catégorie',
    subcategory: 'Sous-catégorie',
    type: 'Type',
    supplier: 'Fournisseur',
    customer: 'Client',
    product: 'Produit',
    description: 'Description',
    notes: 'Notes',
    unit: 'Unité',
    sku: 'SKU',
    value: 'Valeur',
    actions: 'Actions',

    // Orders page (Commandes)
    ordersPage: {
      searchTypeLabel: 'Type de recherche',
      searchReceipt: 'Nom ou numéro',
      searchSupplier: 'Fournisseur',
      searchDate: 'Date précise',
      searchPeriod: 'Période',
      searchReceiptPlaceholder: 'Entrez le nom ou numéro (ex. : ORD69035, Ahmed, produit)',
      dateFrom: 'De date',
      dateTo: 'À date',
      orderStatusFilter: 'Statut de la commande',
      allStatuses: 'Tous les statuts',
      statusEnRoute: 'En route',
      statusDelivered: 'Livrée',
      statusCancelled: 'Annulée',
      newOrder: 'Nouvelle commande',
      importExcel: 'Import Excel',
      bulkDeleteVerb: 'Supprimer',
      bulkDeleteNoun: 'commandes',
      confirmBulkDeleteTitle: 'Confirmer la suppression groupée',
      bulkDeleteMsgPrefix: 'Êtes-vous sûr de vouloir supprimer',
      bulkDeleteMsgSuffix: 'commandes ? Cette action est irréversible.',
      ordersSectionTitle: 'Commandes',
      selectedOrdersSuffix: 'commande(s) sélectionnée(s)',
      emptyNoOrders: 'Aucune commande pour le moment. Cliquez sur « Nouvelle commande » pour commencer.',
      emptyNoMatch: 'Aucune commande ne correspond à vos critères de recherche.',
      productUnknown: 'Produit inconnu',
      unknownSupplier: 'Fournisseur inconnu',
      actionConfirmDelivery: 'Confirmer la livraison',
      actionViewDetails: 'Voir les détails',
      actionEditOrder: 'Modifier la commande',
      actionDeleteOrder: 'Supprimer la commande',
      deleteOrderTitle: 'Confirmer la suppression',
      deleteOrderMessage: 'Êtes-vous sûr de vouloir supprimer cette commande ? Cette action est irréversible.',
      toastProductAdded: 'Produit ajouté avec succès',
      toastSupplierAdded: 'Fournisseur ajouté avec succès',
      toastOrderAdded: 'Commande ajoutée avec succès',
      toastOrderUpdated: 'Commande mise à jour avec succès',
      toastOrderDeleted: 'Commande supprimée avec succès',
      toastOrderCancelled: 'Commande annulée avec succès',
      toastOrderConfirmedStock: 'Commande confirmée et ajoutée aux achats et au stock',
      toastOrderConvertError: 'Erreur lors de la conversion de la commande en achat',
      toastImportSuccess: 'Commandes importées avec succès',
      reportTitlePrefix: 'Rapport des commandes',
      summaryTotalGroups: 'Total commandes',
      summaryEnRoute: 'Commandes en route',
      summaryDelivered: 'Commandes livrées',
      summaryCancelled: 'Commandes annulées',
      bulkDeleteToastFr: 'commandes supprimées avec succès',
      bulkDeleteToastArStart: 'تم حذف',
      bulkDeleteToastArEnd: 'طلبات بنجاح',
      bulkDeleteToast: '{{count}} commandes supprimées avec succès',
      export: {
        orderNum: 'Commande #',
        date: 'Date',
        supplier: 'Fournisseur',
        product: 'Produit',
        quantity: 'Quantité',
        unitPrice: 'Prix unitaire',
        total: 'Total',
        expectedDelivery: 'Livraison prévue',
        status: 'Statut'
      },
      tableOrderDate: 'Date de commande',
      tableOrderId: 'Commande #'
    },

    // Purchases page (Achats)
    purchasesPage: {
      searchTypeLabel: 'Type de recherche',
      searchReceipt: 'Numéro d\'achat ou nom du fournisseur',
      searchSupplier: 'Fournisseur',
      searchDate: 'Date précise',
      searchPeriod: 'Période',
      searchReceiptPlaceholder: 'Entrez le numéro d\'achat ou le nom du fournisseur (ex. : PUR69035, Ahmed)',
      searchSupplierPlaceholder: 'Nom du fournisseur (ex. : Ahmed, Société ABC)',
      dateFrom: 'De date',
      dateTo: 'À date',
      clearSearch: 'Effacer la recherche',
      newPurchase: 'Nouvel achat',
      bulkDeleteVerb: 'Supprimer',
      bulkDeleteNoun: 'achats',
      bulkDeleteMsgPrefix: 'Êtes-vous sûr de vouloir supprimer',
      bulkDeleteMsgSuffix: ' achats ? L\'effet de ces achats sur l\'inventaire sera annulé. Cette action est irréversible.',
      purchasesSectionTitle: 'Achats',
      selectedPurchasesSuffix: 'achat(s) sélectionné(s)',
      emptyNoPurchases: 'Aucun achat pour le moment. Cliquez sur « Nouvel achat » pour commencer.',
      emptyNoMatch: 'Aucun achat ne correspond à vos critères de recherche.',
      productUnknown: 'Produit inconnu',
      actionEditPurchase: 'Modifier l\'achat',
      actionDeletePurchase: 'Supprimer l\'achat',
      actionViewDetails: 'Voir les détails',
      viewPurchaseTitle: 'Détails de l\'achat',
      viewPurchaseId: 'ID achat',
      viewDate: 'Date',
      viewDeliveryDate: 'Date de livraison',
      viewTotalAmount: 'Montant total',
      viewSupplierSection: 'Informations fournisseur',
      viewSupplierName: 'Nom',
      viewSupplierCompany: 'Entreprise',
      viewSupplierEmail: 'Email',
      viewSupplierPhone: 'Téléphone',
      viewSupplierNotFound: 'Informations fournisseur introuvables',
      viewProductsTitle: 'Produits',
      viewColBoxes: 'Boîtes',
      viewColBarcode: 'Code-barres',
      viewColExpiration: 'Expiration',
      viewSummaryItems: 'Total articles',
      viewSummaryAmount: 'Montant total',
      deletePurchaseTitle: 'Confirmer l’annulation',
      deletePurchaseMessage: 'Annuler cet achat marque les lignes et la facture impayée comme annulées, inverse le stock via les mouvements et met à jour l’inventaire. Les enregistrements restent pour l’audit.',
      toastPurchaseDeleted: 'Achat supprimé avec succès',
      toastPurchaseVoided: 'Achat annulé',
      toastPurchaseVoidedDetail: 'Achat annulé — stock et facture fournisseurs mis à jour.',
      alreadyVoided: 'Cet achat est déjà annulé.',
      toastPurchaseAndInvoiceDeleted: 'Achat, lots et facture supprimés — inventaire mis à jour.',
      deleteBlockedPaidInvoice: 'Impossible de supprimer — la facture liée a déjà des paiements.',
      bulkDeleteToastFr: 'achats supprimés avec succès',
      bulkDeleteToastArStart: 'تم حذف',
      bulkDeleteToastArEnd: 'شراء بنجاح',
      bulkDeleteToast: '{{count}} achats supprimés avec succès',
      saveErrorTitle: 'Erreur de sauvegarde',
      saveFailedMessage: 'Achat non enregistré — réessayez',
      invoiceCreated: 'Facture créée',
      invoiceErrorTitle: 'Facture non créée',
      importExcelTitle: 'Importer depuis Excel',
      importExcelLabel: 'Import Excel',
      scanInvoiceLabel: 'File facture',
      scanInvoiceTitle: 'Mettre une facture en file (arrière-plan, sans bloquer)',
      scanInvoiceQueued: 'Facture en file — traitement en arrière-plan',
      scanInvoiceDone: 'Analyse terminée — vérification manuelle requise ({{file}})',
      scanInvoiceError: 'Impossible d\'ajouter la facture à la file',
      scanInvoiceTooLarge: 'Fichier trop volumineux (max 8 Mo)',
      exportPortableLabel: 'Export réimportable',
      exportPortableTitle: 'Export Achats (Excel + JSON avec URLs images)',
      exportPortableSuccess: 'Export prêt — réimportez via Import Excel',
      exportPortableEmpty: 'Aucun achat à exporter',
      exportPortableFailed: 'Échec de l\'export',
      importSuccessTitle: 'Import réussi',
      importSuccessMessage: 'La liste des achats a été mise à jour',
      deleteFailed: 'Échec de la suppression',
      reportTitlePrefix: 'Rapport des achats',
      summaryTotalPurchases: 'Total achats',
      summaryTotalAmount: 'Montant total',
      summaryThisMonth: 'Achats ce mois-ci',
      analyticsTotalPurchases: 'Total achats',
      analyticsPurchasesUnit: 'Achats',
      analyticsTotalAmount: 'Montant total',
      analyticsSpent: 'Dépensé',
      analyticsAvgValue: 'Valeur moyenne',
      analyticsPerPurchase: 'Par achat',
      analyticsTopSupplier: 'Meilleur fournisseur',
      analyticsNotAvailable: 'N/D',
      loadingData: 'Chargement des données…',
      tablePurchaseId: 'Achat #',
      tableUnitPrice: 'Prix unitaire',
      tableItemsCount: 'Articles',
      tablePurchaseTotal: 'Total achat',
      tableClickHint: 'Cliquer pour voir les produits',
      viewColSellingPrice: 'Prix de vente',
      tableDeliveryDate: 'Date de livraison',
      tableExpirationDate: 'Date d\'expiration',
      tableLocation: 'Emplacement',
      export: {
        purchaseNum: 'Achat #',
        date: 'Date',
        supplier: 'Fournisseur',
        product: 'Produit',
        quantity: 'Quantité',
        unitPrice: 'Prix Unitaire',
        total: 'Total',
        deliveryDate: 'Date de Livraison',
        expirationDate: 'Date d\'Expiration',
        location: 'Emplacement',
        imageUrl: 'URL image'
      }
    },

    expensesPage: {
      reportTitlePrefix: 'Rapport des dépenses',
      summaryTotal: 'Total dépenses',
      summaryCustoms: 'Douanes',
      summaryTransport: 'Transport',
      paymentCashLabel: 'Espèces',
      confirmOverAmount: 'Montant ({{amount}}) supérieur au disponible ({{available}}). Continuer enregistrera un financement externe (solde négatif).{{suffix}}',
      overAmountSuggestion: ' Suggestion: {{method}}',
      errorOverAmount: 'Montant supérieur au solde disponible pour cette méthode ({{available}}). {{tail}}',
      overAmountSuggestionTail: 'Suggestion: {{method}}.',
      overAmountNegativeHint: 'L\'écart apparaîtra en financement externe (solde négatif) dans le rapport.',
      confirmExpenseSetupPhase: 'Phase installation : cette dépense sera en financement externe — {{amount}}',
      confirmExpenseCrossMethod: 'Le montant ({{amount}}) dépasse le disponible sur la méthode choisie. Répartition : {{split}}{{external}}',
      confirmExpenseExternalAddon: ', externe : {{amount}}',
      fundingRegisterLabel: 'caisse',
      fundingExternalLabel: 'externe',
      errCashRegisterExpense: 'Échec de la mise à jour de la caisse — dépense non enregistrée',
      export: {
        date: 'Date',
        category: 'Catégorie',
        description: 'Description',
        amount: 'Montant',
        paymentMethod: 'Méthode de paiement'
      }
    },

    suppliersPage: {
      deleteSupplierTitle: 'Confirmer la suppression',
      deleteSupplierMessage: 'Êtes-vous sûr de vouloir supprimer ce fournisseur ? Cette action est irréversible.',
      editSupplierTitle: 'Modifier le fournisseur',
      supplierInfoSection: 'Informations du fournisseur',
      company: 'Entreprise',
      updateSupplier: 'Mettre à jour le fournisseur',
      selectStatus: 'Sélectionner le statut',
      searchTypeLabel: 'Type de Recherche',
      searchNameOrPhone: 'Nom ou Téléphone',
      searchJoinDate: 'Date d\'Inscription',
      searchJoinPeriod: 'Période d\'Inscription',
      nameSearchPlaceholder: 'Entrez le nom du fournisseur ou le numéro de téléphone',
      dateFrom: 'De Date',
      dateTo: 'À Date',
      addSupplier: 'Ajouter Fournisseur',
      suppliersTitle: 'Fournisseurs',
      totalSuppliersCount: 'Total : {{count}} fournisseurs',
      tableSupplierId: 'ID Fournisseur',
      tableName: 'Nom',
      tableCompany: 'Entreprise',
      tableEmail: 'Email',
      tablePhone: 'Téléphone',
      tableAddress: 'Adresse',
      tableStatus: 'Statut',
      tableJoinDate: 'Date d\'Adhésion',
      tableActions: 'Actions',
      emptyNoSuppliers: 'Aucun fournisseur ajouté encore. Cliquez sur « Ajouter Fournisseur » pour commencer.',
      emptyNoMatch: 'Aucun fournisseur ne correspond à vos critères de recherche.',
      actionViewPurchases: 'Voir Achats',
      actionEditSupplier: 'Modifier Fournisseur',
      actionDeleteSupplier: 'Supprimer Fournisseur',
      viewSupplierTitle: 'Détails du Fournisseur',
      labelCompanyEmpty: 'Entreprise non renseignée',
      contactSection: 'Coordonnées',
      labelPhoneShort: 'Téléphone',
      labelEmailShort: 'Email',
      labelAddressShort: 'Adresse',
      noContactInfo: 'Aucune coordonnée enregistrée',
      purchasesPeriodAria: 'Filtrer les achats par période',
      labelCompany: 'Entreprise :',
      labelEmail: 'Email :',
      labelPhone: 'Téléphone :',
      labelAddress: 'Adresse :',
      labelStatus: 'Statut :',
      labelJoinDate: 'Date d\'Adhésion :',
      purchasesTitle: 'Achats',
      periodAll: 'Tout le Temps',
      periodToday: 'Aujourd\'hui',
      periodWeek: 'Cette semaine',
      periodMonth: 'Ce mois',
      periodQuarter: 'Ce trimestre',
      periodYear: 'Cette année',
      purchaseColProduct: 'Produit',
      purchaseColQty: 'Quantité',
      purchaseColUnitPrice: 'Prix Unitaire',
      purchaseColTotal: 'Total',
      purchaseColDeliveryDate: 'Date de Livraison',
      noPurchasesForSupplier: 'Aucun achat pour ce fournisseur',
      statusActive: 'Actif',
      statusInactive: 'Inactif',
      statusPending: 'En attente',
      reportTitlePrefix: 'Rapport des Fournisseurs',
      summaryTotalSuppliers: 'Total Fournisseurs',
      summaryActiveSuppliers: 'Fournisseurs Actifs',
      export: {
        supplierId: 'ID Fournisseur',
        name: 'Nom',
        company: 'Entreprise',
        email: 'Email',
        phone: 'Téléphone',
        address: 'Adresse',
        status: 'Statut',
        date: 'Date'
      }
    },

    customersPage: {
      searchTypeLabel: 'Type de recherche',
      searchNameOrPhone: 'Nom ou téléphone',
      searchJoinDate: 'Date d\'inscription',
      searchJoinPeriod: 'Période d\'inscription',
      clearSearch: 'Effacer la recherche',
      nameSearchPlaceholder: 'Entrez le nom ou le numéro de téléphone (ex. : Ahmed, 22234567)',
      newCustomer: 'Nouveau client',
      salesModalTitle: 'Ventes client',
      salesModalTitleWithName: 'Ventes à {{name}}',
      customerLabel: 'Client :',
      noEmail: 'Pas d\'e-mail',
      filterByPeriod: 'Filtrer par période :',
      periodAll: 'Tout le temps',
      periodThisMonth: 'Ce mois-ci',
      periodLast3Months: '3 derniers mois',
      periodLast6Months: '6 derniers mois',
      periodLastYear: 'Dernière année',
      errorMissingCustomerId: 'Erreur : ID client manquant',
      noSalesForCustomer: 'Aucune vente enregistrée pour ce client pour le moment.',
      salesTableOrderId: 'ID commande',
      salesTableDate: 'Date',
      salesTableProduct: 'Produit',
      salesTableQuantity: 'Quantité',
      salesTableUnitPrice: 'Prix de vente',
      salesTableTotal: 'Total',
      salesTableStatus: 'Statut',
      undefinedShort: 'Non défini',
      customersTitle: 'Clients',
      totalCustomersCount: 'Total : {{count}} clients',
      tableCustomerId: 'ID client',
      tableName: 'Nom',
      tableEmail: 'E-mail',
      tablePhone: 'Téléphone',
      tableAddress: 'Adresse',
      tableTotalOrders: 'Total commandes',
      tableTotalSpent: 'Total dépensé',
      tableDebt: 'Dette client',
      tableStatus: 'Statut',
      tableNotes: 'Notes',
      tableJoinDate: 'Date d\'adhésion',
      tableActions: 'Actions',
      emptyNoCustomers: 'Aucun client pour le moment. Cliquez sur « Nouveau client » pour commencer.',
      emptyNoMatch: 'Aucun client ne correspond à vos critères de recherche.',
      notProvided: 'Non renseigné',
      noDebt: 'Aucune',
      noNotes: 'Aucune note',
      actionViewSales: 'Voir les ventes',
      actionEditCustomer: 'Modifier le client',
      actionCollectDebt: 'Encaisser la créance',
      debtPaymentTitle: 'Encaisser une créance',
      debtPaymentRemaining: 'Reste à payer',
      debtPaymentAmount: 'Montant reçu',
      debtPaymentMethod: 'Mode de paiement',
      debtPaymentCash: 'Espèces',
      debtPaymentElectronic: 'Électronique',
      debtPaymentProvider: 'Opérateur',
      debtPaymentNote: 'Note (optionnel)',
      debtPaymentNotePlaceholder: 'Référence, reçu…',
      debtPaymentConfirm: 'Enregistrer le paiement',
      debtPaymentSaving: 'Enregistrement…',
      debtPaymentInvalidAmount: 'Montant invalide',
      debtPaymentExceedsRemaining: 'Le montant dépasse la dette restante',
      debtPaymentNoDebt: 'Aucune dette ouverte pour ce client',
      debtPaymentFailed: 'Échec du paiement ({{error}})',
      debtPaymentSuccess: 'Paiement enregistré : {{amount}}',
      debtPaymentHistory: 'Historique des encaissements',
      debtPaymentHistoryEmpty: 'Aucun encaissement enregistré pour ce client',
      editCustomerTitle: 'Modifier le client',
      customerInfoSection: 'Informations client',
      updateCustomer: 'Mettre à jour le client',
      optionalEmail: 'E-mail (optionnel)',
      optionalPhone: 'Téléphone (optionnel)',
      optionalAddress: 'Adresse (optionnelle)',
      optionalNotes: 'Notes sur le client (optionnel)',
      statusActive: 'Actif',
      statusInactive: 'Inactif',
      statusPending: 'En attente',
      statusVip: 'VIP',
      reportTitlePrefix: 'Rapport clients',
      summaryTotalCustomers: 'Total clients',
      summaryActiveCustomers: 'Clients actifs',
      summaryTotalDebts: 'Total dettes',
      dateFrom: 'Du',
      dateTo: 'Au',
      export: {
        customerId: 'ID client',
        name: 'Nom',
        email: 'E-mail',
        phone: 'Téléphone',
        address: 'Adresse',
        orders: 'Commandes',
        spent: 'Dépensé',
        debt: 'Dette',
        status: 'Statut',
        date: 'Date'
      }
    },

    salesPage: {
      pageTitle: 'Ventes',
      searchTypeLabel: 'Type de recherche',
      searchReceipt: 'Numéro de vente ou nom du client',
      searchDatePrecise: 'Date précise',
      searchPeriod: 'Période',
      searchWeek: 'Une semaine',
      searchMonth: 'Un mois',
      searchThreeMonths: 'Trois mois',
      searchMonthYear: 'Mois & année',
      dateFilterLabel: 'Date',
      dateFilterAll: 'Toutes',
      clearSearch: 'Effacer la recherche',
      searchFieldLabel: 'Recherche',
      searchPlaceholder: 'Entrez le numéro de vente ou le nom du client (ex. : VENTE900375, Ahmed)',
      dateFrom: 'Du',
      dateTo: 'Au',
      paymentFilterLabel: 'Paiement',
      paymentFilterAll: 'Tous',
      paymentFilterCash: 'Espèces',
      paymentFilterElectronic: 'Électronique',
      paymentFilterCredit: 'Créances',
      deliveryFilterLabel: 'Livraison',
      deliveryFilterAll: 'Toutes',
      deliveryFilterDelivery: 'Livraison',
      deliveryFilterNonDelivery: 'Sans livraison',
      summaryCreancesUnpaid: 'Créances (impayé)',
      actionsColumn: 'Actions',
      viewLabel: 'Vue',
      viewTable: 'Table',
      viewReport: 'Rapport',
      viewExport: 'Export',
      bulkDeleteCount: 'Supprimer {{count}} ventes',
      analyticsTotalSales: 'Total ventes',
      analyticsSalesUnit: 'Ventes',
      analyticsRevenue: 'Chiffre d\'affaires',
      analyticsReceived: 'Reçu',
      analyticsAvgOrder: 'Panier moyen',
      analyticsPerSale: 'Par vente',
      analyticsTopCustomer: 'Meilleur client',
      loadingData: 'Chargement des données…',
      notAvailable: 'N/D',
      customerUnspecified: 'Non spécifié',
      statusCompleted: 'Terminé',
      statusPending: 'En attente',
      statusCancelled: 'Annulé',
      statusModified: 'Modifié',
      listTitle: 'Liste des ventes',
      tableReceipt: 'N° reçu',
      tableDate: 'Date',
      tableTime: 'Heure',
      tableClient: 'Client',
      tableProducts: 'Produits',
      tableAmount: 'Montant',
      tableStatus: 'Statut',
      tablePaymentMethod: 'Paiement',
      tableActions: 'Actions',
      deliverySaleBadge: 'Livraison',
      productCountSuffix: 'produit(s)',
      actionViewDetails: 'Voir les détails',
      actionMerchantReceipt: 'Voir la facture commerçant',
      actionDeleteSale: 'Supprimer la vente',
      emptyTitle: 'Aucune vente',
      emptyDescription: 'Aucune vente ne correspond aux critères sélectionnés.',
      reportTitlePrefix: 'Rapport des ventes',
      summaryTotalSales: 'Total ventes',
      summaryTotalRevenue: 'Revenus totaux',
      summaryCompleted: 'Ventes complétées',
      exportDataTitle: 'Exporter les données',
      exportChooseFormat: 'Choisir le format d\'export',
      deleteConfirmTitle: 'Confirmer la suppression',
      deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer la vente {{orderId}} ? Cette action ne peut pas être annulée.',
      bulkDeleteConfirmTitle: 'Confirmer la suppression multiple',
      bulkDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer {{count}} ventes ? Cette action ne peut pas être annulée.',
      deleteFailed: 'Échec de la suppression de la vente',
      bulkDeleteFailed: 'Échec de la suppression groupée',
      tableWorker: 'Employé',
      restaurantMenuPieces: 'pièces menu',
      export: {
        receiptNum: 'N° reçu',
        date: 'Date',
        time: 'Heure',
        client: 'Client',
        products: 'Produits',
        amount: 'Montant',
        paymentMethod: 'Paiement'
      }
    },

    reportsPage: {
      pageTitle: 'Rapports & Analyses',
      cacheLoading: 'Chargement des données...',
      cacheReady: 'Données mises à jour et optimisées',
      calculationsLoading: 'Calcul couverture / réappro…',
      calculationsError: 'Erreur lors du calcul des rapports',
      sectionStockMovement: 'Couverture stock',
      sectionExpirationAlerts: 'Alertes expiration',
      sectionExpiredProducts: 'Produits expirés',
      sectionBalanceSheet: 'Bilan',
      sectionFoodCost: 'Coût alimentaire',
      stockMovementTitle: 'Couverture & réappro',
      stockCoverageHint:
        'Vue couverture et réapprovisionnement (acheté / vendu, stock). Pour le journal des mouvements : Stock → Historique des mouvements.',
      linkLedgerHistory: 'Ouvrir l’historique des mouvements',
      reorderBacktestTitle: 'Suivi réappro (30 j.)',
      reorderBacktestSummary:
        '{{needing}} à réappro · achats {{hitPct}}% · couverture qté {{fillPct}}% · sous-commandés {{under}} · fenêtre {{days}} j.',
      managerInsightsTitle: 'Indicateurs manager',
      insightClickHint: 'cliquer pour ouvrir',
      insightReorderUrgent: '{{count}} produit(s) à réapprovisionner — priorité: {{names}}',
      insightReorderUrgentAction: 'Passer commande ou vérifier les achats en cours',
      insightTransfer: '{{count}} transfert(s) utiles — {{names}}',
      insightTransferAction: 'Transférer depuis les autres emplacements vers Principal',
      insightExpiry: '{{count}} alerte(s) expiration ({{urgent}} urgentes)',
      insightExpiryAction: 'Ouvrir Alertes expiration / rotation FEFO',
      insightSlowMovers: '{{count}} rotation lente — {{names}}',
      insightSlowMoversAction: 'Promo, transfert ou pause d\'achat',
      insightLowCoverage: '{{count}} couverture faible — {{names}}',
      insightLowCoverageAction: 'Surveiller la rupture imminente',
      insightBacktestGap:
        'Suivi réappro faible: {{hitPct}}% d\'achats sur {{needing}} suggestions ({{under}} sous-commandés, {{days}} j.)',
      insightBacktestGapAction: 'Comparer suggestions et bons d\'achat récents',
      linkAchatVsVente: 'Voir Achat vs Vente',
      searchProductsPlaceholder: 'Rechercher des produits...',
      sortUpdatedAt: 'Dernière mise à jour',
      sortProduct: 'Produit',
      sortPurchased: 'Acheté',
      sortSold: 'Vendu',
      sortInStock: 'En stock',
      sortAsc: 'Croissant',
      sortDesc: 'Décroissant',
      perfNormal: 'Normal',
      perfBest: 'Meilleur',
      perfWorst: 'Pire',
      periodChoose: 'Choisir la période',
      periodLastYear: 'Dernière année',
      periodLast6Months: '6 derniers mois',
      periodLast3Months: '3 derniers mois',
      periodDatePrecise: 'Date précise',
      periodRange: 'Période',
      datePrecise: 'Date précise',
      dateFrom: 'Du',
      dateTo: 'Au',
      recordsCleared: '{{count}} enregistrements supprimés effacés',
      recordsClearError: 'Erreur lors de l\'effacement des enregistrements',
      stockReportCardTitle: 'Rapport de Mouvement de Stock',
      stockColProduct: 'Produit',
      stockColPurchased: 'Acheté',
      stockColSold: 'Vendu',
      stockColInStockDetail: 'En stock / détail',
      stockColAvgSales: 'Moy. ventes/jour (principal)',
      stockColCoverage: 'Couverture (jours)',
      stockColReorder: 'Qté réappro. sugg.',
      stockColTransfer: 'Qté transfert sugg.',
      stockColConservation: 'Conservation',
      stockTotal: 'Total',
      stockStartup: 'Démarrage',
      stockTarget: 'Cible',
      summaryTotalProducts: 'Total produits',
      summaryLowCoverage: 'Produits à couverture faible',
      summaryToReorder: 'Produits à réapprovisionner',
      expirationSectionHeading: 'Alerte d\'expiration de produit (par type de conservation)',
      expirationCardTitle: 'Alerte d\'expiration de produit',
      expColProduct: 'Produit',
      expColQtyRemaining: 'Quantité restante',
      expColExpiry: 'Date d\'expiration',
      expColDaysRemaining: 'Jours restants',
      expColLocation: 'Lieu',
      expColLot: 'Numéro de lot',
      expColConservationType: 'Type de conservation',
      expColActionRequired: 'Action requise',
      conservationPERISSABLE: 'Périssable',
      conservationCOURTE: 'Courte',
      conservationMOYENNE: 'Moyenne',
      conservationLONGUE: 'Longue',
      conservationSANS_DATE: 'Sans date',
      conservationNORMAL: 'Normal',
      actionURGENT: 'Urgent',
      actionATTENTION: 'Attention',
      actionSURVEILLER: 'Surveiller',
      locPrincipal: 'Principal',
      locEntrepot: 'Entrepôt',
      locBoutique: 'Boutique',
      locMagasin: 'Magasin',
      locOther: 'Autre',
      expiredCardTitle: 'Produits expirés',
      expiredColProduct: 'Produit',
      expiredColQuantity: 'Quantité',
      expiredColExpiration: 'Date d\'expiration',
      expiredColPurchase: 'Date d\'achat',
      expiredColLocation: 'Lieu',
      expiredColStatus: 'Statut',
      expiredColActions: 'Actions',
      expiredProcess: 'Traiter expirés',
      expiredProcessTitle: 'Traiter les produits expirés',
      expiredProcessStockHint: 'Retire les quantités expirées des lots, met à jour le stock et crée les lignes « produits expirés ».',
      expiredClearRecords: 'Effacer les enregistrements',
      expiredClearRecordsTitle: 'Effacer les enregistrements supprimés (test)',
      expiredReset: 'Réinitialiser',
      expiredDeleteTitle: 'Supprimer',
      expiredDeleteSuccess: 'Produit expiré supprimé',
      expiredDeleteError: 'Erreur lors de la suppression',
      expiredStatusRemoved: 'Retirer du stock',
      expiredStatusExpired: 'Expiré',
      balanceTypeCurrent: 'Actuel',
      balanceTypeYearly: 'Annuel',
      balanceCloseToday: 'Clôturer la journée',
      balanceClosingHistory: 'Historique des clôtures',
      balancePeriodClosingHistory: 'Clôtures périodiques',
      balancePeriodReviewPendingTitle: 'Synchronisation suspendue',
      balancePeriodReviewPendingHint:
        'Vérifiez la clôture périodique avant reprise de l’upload : {{periods}}',
      closingTableauTitle: 'Clôture du jour',
      closingTableauHint:
        'Totaux alignés sur le Tableau de bord (sorties caisse / liquidité).',
      closingTableauStatusOpen: 'Journée ouverte',
      closingTableauStatusClosed: 'Journée clôturée',
      closingTableauPrevious: 'Clôture précédente (date & heure)',
      closingTableauCurrent: 'Clôture actuelle (date & heure)',
      closingTableauNone: 'Aucune',
      closingTableauPendingNow: 'En cours — {{date}}',
      closingTableauColLabel: 'Libellé',
      closingTableauColAmount: 'Montant',
      closingTableauRevenue: 'Revenus (ventes)',
      closingTableauPayments: 'Paiements fournisseurs',
      closingTableauExpenses: 'Dépenses (portion caisse)',
      closingTableauOutgoing: 'Total sorties caisse',
      closingTableauNet: 'Net trésorerie',
      closingTableauExpenseDetail: 'Détail des dépenses du jour',
      closingTableauColExpense: 'Dépense',
      closingTableauColRegister: 'Caisse',
      closingTableauColAccrual: 'Montant total',
      closingTableauExternal: 'Hors caisse',
      closingTableauNoExpenses: 'Aucune dépense enregistrée aujourd’hui.',
      balanceClosingSuccess: 'Journée clôturée avec succès',
      balanceClosingAlreadyClosed: 'Cette journée est déjà clôturée',
      balanceClosingFailed: 'Échec de la clôture',
      balanceClosingConfirm: 'Clôturer la journée en cours ?',
      balanceClosingActiveSessionsWarning: 'Attention : {{count}} session(s) caissier encore active(s).',
      balanceClosingSuccessWithWarnings: 'Journée clôturée (avec avertissements — voir historique).',
      balanceClosingInProgress: 'Clôture en cours…',
      balanceResetTodayClosing: 'Réinitialiser la clôture du jour',
      balanceYearlyTitle: 'Bilan annuel {{year}}',
      balanceYearlyClosings: '{{count}} clôtures quotidiennes',
      balancePeriodBanner: 'Période du bilan : {{from}} – {{to}}',
      balancePeriodAll: 'Toutes les dates',
      balanceExportColLabel: 'Libellé',
      balanceExportColAmount: 'Montant',
      balanceAssetsTitle: 'Actifs',
      balanceLiabilitiesTitle: 'Passifs',
      balanceEquityTitle: 'Capitaux propres',
      balanceCurrentAssetsSection: 'Actifs courants',
      balanceCash: 'Espèces',
      balanceCashRegister: 'Solde caisse (espèces)',
      balanceOpeningCashRemaining: 'Capital démarrage restant (espèces)',
      balanceBank: 'Banque / électronique',
      balanceBankDetailHint: 'Détail par moyen : Bankily, Sedad, Massrivi…',
      balanceFinancingOffBalanceTitle: 'Financement (hors solde caisse)',
      balanceFinancingOffBalanceHint: 'Ne réduit pas le solde — détail par méthode de paiement.',
      balanceOpeningCapitalUsed: 'Capital démarrage utilisé',
      balanceExternalFinancingUsed: 'Financement externe',
      balanceAccountsReceivable: 'Créances clients (vente à crédit)',
      balanceInventory: 'Inventaire',
      balanceFixedAssetsSection: 'Actifs fixes (Capital actif)',
      balanceProperty: 'Immobilier',
      balanceEquipment: 'Équipement',
      balanceVehicles: 'Véhicules',
      balanceOtherFixed: 'Autres',
      balanceActiveCapital: 'Capital actif',
      balanceTotalCurrentAssets: 'Total actifs courants',
      balanceTotalAssets: 'Total Actifs',
      balanceCurrentLiabilitiesSection: 'Passifs courants',
      balanceAccountsPayable: 'Dettes fournisseurs (nous devons)',
      balanceAcceptedEcartLosses: 'Pertes d\'écarts (acceptés)',
      balanceAcceptedEcartGains: 'Gains d\'écarts (acceptés)',
      balanceExpirationLosses: 'Pertes par expiration',
      balanceLiabilitiesByPeriod: 'Échéances (indicatif)',
      balanceCurrentQuarter: 'Échéance ≤ fin du trimestre',
      balanceCurrentYearPeriod: 'Échéance ≤ fin d’année',
      balanceLongTermLiabilitiesSection: 'Passifs à long terme',
      balanceLoans: 'Emprunts',
      balanceMortgages: 'Hypothèques',
      balanceForeignCapital: 'Capital étranger',
      balanceTotalLiabilities: 'Total Passifs',
      balanceTotalLiabilitiesAndEquity: 'Total Passifs + Capitaux propres',
      balanceEquityCapital: 'Capital',
      balanceEditOpeningCapital: 'Configurer le capital de démarrage →',
      balanceRetainedEarnings: 'Bénéfices non répartis',
      balanceCurrentYearProfit: 'Bénéfice année en cours',
      balanceOwnCapital: 'Capital propre',
      balanceTotalEquity: 'Total Capitaux propres',
      balanceEquationLabel: 'Équation du bilan',
      balanceEquationHint: 'Actifs = Passifs + Capitaux propres',
      balanceStatusOk: '✅ Bilan équilibré',
      balanceStatusWarn: '⚠️ Bilan déséquilibré',
      balanceDifference: 'Différence',
      balanceFinancialSummaryTitle: 'Résumé financier',
      balanceTotalRevenue: 'Chiffre d\'affaires',
      balanceOperatingExpenses: 'Dépenses d\'exploitation',
      balanceNetProfit: 'Résultat net',
      balanceLiquidCashLabel: 'Solde espèces (flux)',
      balanceLiquidBankLabel: 'Solde électronique (flux)',
      balanceLiquidHint: 'Les soldes espèces et banque correspondent au « Rapport des paiements » (entrant − sortie). Les dépenses sont déduites du cash et du résultat, pas des passifs.',
      balancePaymentReportReference: 'Voir Rapport des paiements (tableau de bord manager)',
      balanceDailyClosingHistory: 'Historique des clôtures journalières',
      ecartBreakdownTitle: 'Calcul du montant attendu',
      ecartBreakdownHint:
        'Fond de caisse + ventes + encaissements créances − sorties caisse = montant attendu.',
      ecartBreakdownInitial: 'Fond de caisse (début de session)',
      ecartBreakdownCashSales: '+ Ventes espèces',
      ecartBreakdownCashDebt: '+ Encaissements créances (espèces)',
      ecartBreakdownCashOutgoing: '− Sorties espèces (dépenses + achats)',
      ecartBreakdownExpectedCash: '= Montant attendu (espèces)',
      ecartBreakdownCashSection: 'Espèces',
      ecartBreakdownInitialElectronic: 'Solde électronique initial',
      ecartBreakdownElectronicSales: '+ Ventes électroniques',
      ecartBreakdownElectronicDebt: '+ Encaissements créances (électronique)',
      ecartBreakdownElectronicOutgoing: '− Sorties électroniques',
      ecartBreakdownExpectedElectronic: '= Montant électronique attendu',
      ecartBreakdownElectronicSection: 'Électronique',
      paymentReportBalanceHint: 'Ces soldes correspondent aux montants « Espèces » et « Banque » du bilan (Rapports → Bilan).',
      balanceDeleteConfirmTitle: 'Confirmer la suppression',
      balanceDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer le produit expiré « {{product}} » ? Cette action ne peut pas être annulée.'
    },

    // Packaging
    packagingType: 'Type d\'Emballage',
    unitary: 'Unitaire',
    package: 'Carton',
    productsPerPackage: 'Produits par Carton',
    numberOfPackages: 'Nombre de Cartons',
    totalQuantity: 'Quantité Totale',
    packagePrice: 'Prix du Carton',
    unitPrice: 'Prix Unitaire',
    sellingPrice: 'Prix de Vente',

    // Messages
    noDataFound: 'Aucune donnée trouvée',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Avertissement',
    info: 'Information',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    dataSaved: 'Données sauvegardées avec succès',
    dataDeleted: 'Données supprimées avec succès',
    dataUpdated: 'Données mises à jour avec succès',
    isRequired: 'est requis',
    mustBeValid: 'doit être valide',
    optional: 'Optionnel',
    relatedTo: 'Lié à',
    none: 'Aucun',
    all: 'Tous',
    monthlyExpenses: 'Dépenses Mensuelles',
    allExpenses: 'Toutes les dépenses',
    expenseReport: 'Rapport des Dépenses',
    customPeriod: 'Période Personnalisée',
    lastWeek: 'Semaine Dernière',
    lastMonth: 'Mois Dernier',
    startDate: 'Date de Début',
    endDate: 'Date de Fin',
    accessDenied: 'Accès Refusé',
    noPermission: 'Vous n\'avez pas la permission d\'accéder à cette page',
    paymentMethod: 'Méthode de Paiement',
    cash: 'Espèces',
    bankTransfer: 'Virement Bancaire',
    check: 'Chèque',
    mobileMoney: 'Mobile Money',
    today: 'Aujourd\'hui',
    quickSaleCashRegister: 'Caisse de Vente Rapide',
    currentBalance: 'Solde actuel',
    sessionCashExpected: 'Montant attendu (session active)',

    // Dashboard
    totalProducts: 'Total des Produits',
    totalCustomers: 'Total des Clients',
    totalSuppliers: 'Total des Fournisseurs',
    totalSales: 'Total des Ventes',
    totalPurchases: 'Total des Achats',
    monthlyRevenue: 'Revenus Mensuels',
    monthlyProfit: 'Profit Mensuel',
    recentActivities: 'Activités Récentes',
    inventoryAlerts: 'Alertes d\'Inventaire',
    quickActions: 'Actions Rapides',

    // Inventory
    addProduct: 'Ajouter un Produit',
    editProduct: 'Modifier le Produit',
    productName: 'Nom du Produit',
    currentStock: 'Stock Actuel',
    lowStock: 'Stock Faible',
    outOfStock: 'Rupture de Stock',
    inStock: 'En Stock',
    stock: 'Stock',

    // Sales
    addSale: 'Ajouter une Vente',
    editSale: 'Modifier la Vente',
    saleDate: 'Date de Vente',
    customerName: 'Nom du Client',
    saleTotal: 'Total de la Vente',
    paymentMethod: 'Méthode de Paiement',
    cash: 'Espèces',
    card: 'Carte',
    transfer: 'Virement',

    // Payment Management
    paymentManagement: 'Paiement Factures',
    managePayments: 'Paiement Factures',
    manageSupplierInvoices: 'Gestion des factures fournisseurs et paiements',
    paymentManagementReport: 'Rapport de Gestion des Paiements',
    invoiceId: 'ID Facture',
    invoiceNumber: 'N° Facture',
    notAvailable: 'N/D',
    pending: 'En attente',
    dueDate: 'Date d\'échéance',
    totalInvoices: 'Total des Factures',
    pendingPayments: 'Paiements en Attente',
    paidInvoices: 'Factures Payées',
    totalAmount: 'Montant Total',
    paidAmount: 'Montant Payé',
    remainingAmount: 'Montant Restant',
    partialInvoices: 'Factures Partielles',
    pendingInvoices: 'Factures en Attente',
    openInvoices: 'Factures Ouvertes',
    noOpenInvoices: 'Aucune facture ouverte',
    allInvoicesPaid: 'Toutes les factures sont payées',
    paidStatus: 'Payé',
    partialStatus: 'Partiellement payé',
    pendingStatus: 'En attente',
    newInvoicesCreated: 'nouvelles factures créées',
    noNewInvoices: 'Aucune nouvelle facture à créer',
    errorCreatingInvoices: 'Erreur lors de la création des factures',
    confirmDeleteAll: 'Êtes-vous sûr de vouloir supprimer toutes les factures ?',
    invoiceManagement: 'Gestion des Factures',
    createInvoicesFromPurchases: 'Créer des factures à partir des achats',
    deleteAllInvoices: 'Supprimer toutes les factures',
    allInvoices: 'Toutes les factures',
    invoiceValue: 'Valeur des factures',
    paid: 'Payé',
    toPay: 'À payer',
    complete: 'Complet',
    partiallyPaid: 'Partiellement payé',
    unpaid: 'Non payé',
    withDebt: 'avec dette',
    recentInvoices: 'Factures récentes',
    noInvoices: 'Aucune facture',

    // Accounts Receivable = ventes à crédit (le client nous doit)
    accountsReceivable: 'Créances clients',
    customerDebts: 'Créances clients (vente à crédit)',
    customerInvoices: 'Factures clients',
    customerCredit: 'Crédit client',
    creditLimit: 'Limite de crédit',
    creditUsed: 'Crédit utilisé',
    creditAvailable: 'Crédit disponible',
    customerInvoice: 'Facture client',
    createCustomerInvoice: 'Créer une facture client',
    customerPayment: 'Paiement client',
    addCustomerPayment: 'Ajouter un paiement client',
    totalCustomerDebt: 'Total créances clients',
    remainingCustomerDebt: 'Créance restante',
    customerCreditLimit: 'Limite de crédit client',
    creditExceeded: 'Limite de crédit dépassée',
    creditWarning: 'Avertissement: proche de la limite de crédit',

    // Expenses
    expenses: 'Dépenses',
    expense: 'Dépense',
    addExpense: 'Ajouter une dépense',
    editExpense: 'Modifier une dépense',
    expenseCategory: 'Catégorie de dépense',
    expenseCategories: {
      rent: 'Loyer',
      utilities: 'Services publics',
      salaries: 'Salaires',
      marketing: 'Marketing',
      maintenance: 'Maintenance',
      office: 'Bureau',
      travel: 'Voyage',
      taxes: 'Impôts',
      interest: 'Intérêts',
      customs: 'Douane',
      transport: 'Transport',
      shipping: 'Expédition',
      other: 'Autre'
    },
    totalExpenses: 'Total des dépenses',
    expenseDate: 'Date de dépense',
    expenseDescription: 'Description de la dépense',
    expenseReceipt: 'Reçu de dépense',
    monthlyExpenses: 'Dépenses mensuelles',
    expenseReport: 'Rapport de dépenses',
    customs: 'Douane',
    transport: 'Transport',

    // Error Messages
    validationError: 'Erreur de Validation',
    stockError: 'Erreur de Stock',
    insufficientStock: 'Stock insuffisant',
    productNotAvailable: 'Produit non disponible en stock',
    error: 'Erreur',
    cannotSaveEmptyDraft: 'Impossible de sauvegarder un brouillon vide',
    saved: 'Sauvegardé',
    draftSavedSuccess: 'Brouillon sauvegardé avec succès',
    invalidDraft: 'Brouillon invalide',
    loaded: 'Chargé',
    draftLoadedSuccess: 'Brouillon chargé avec succès',
    deleted: 'Supprimé',
    draftDeletedSuccess: 'Brouillon supprimé avec succès',
    allDraftsDeleted: 'Tous les brouillons supprimés',
    allDraftsDeletedSuccess: 'Tous les brouillons ont été supprimés avec succès',
    emptyCart: 'Panier vide',
    addProductsBeforeSale: 'Ajoutez des produits avant de finaliser la vente',
    amountError: 'Erreur de Montant',
    insufficientAmount: 'Montant insuffisant',
    preparationError: 'Erreur de préparation',
    cannotPrepareSale: 'Impossible de préparer la vente',
    saleConfirmedSuccess: 'Vente confirmée avec succès',
    saleSavedSuccess: 'Vente sauvegardée avec succès',
    validationErrorTitle: 'Erreur de validation',
    stockErrorTitle: 'Erreur de stock',
    paymentError: 'Erreur de paiement',
    cartCleared: 'Panier vidé',
    
    // UI Labels
    searchPlaceholder: 'Rechercher par nom, SKU ou code-barres…',
    stockLabel: 'Stock:',
    saleDrafts: 'Brouillons de vente',
    drafts: 'Brouillons',
    scanBarcode: 'Scanner le code-barres',
    scan: 'Scanner',
    fullscreen: 'Plein écran',
    
    // Legacy compatibility
    locations: {
      'Principal': 'Principal',
      'Secondaire': 'Secondaire',
      'Other': 'Autre',
      'Entrepôt': 'Entrepôt',
      'Boutique': 'Boutique',
      'Magasin': 'Magasin'
    },

    posPage: {
      cart: 'Panier',
      clearCart: 'Vider',
      clearCartTitle: 'Vider le panier',
      decrease: 'Diminuer',
      increase: 'Augmenter',
      editPrice: 'Modifier le prix',
      editPackPrice: 'Modifier le prix carton',
      packLineTag: '{{packs}} carton(s) × {{units}} u.',
      packQtyBaseUnits: 'Quantité en cartons (stock = unités)',
      checkoutSteps: 'Étapes de caisse',
      stepCart: 'Panier',
      stepPayment: 'Paiement',
      stepReceipt: 'Reçu',
      linesLabel: 'Lignes',
      qtyShort: 'Qté',
      cartColQty: 'Qté',
      cartColUnitPrice: 'Prix unit.',
      cartColSubtotal: 'Sous-total',
      payment: 'Paiement',
      electronic: 'Électronique',
      credit: 'Crédit',
      creditHint: 'Vente à crédit — client sur le reçu (sélection / création). Aucune entrée caisse pour le reste.',
      creditDeposit: 'Acompte payé maintenant',
      creditDepositMethod: 'Mode de l\'acompte',
      creditRemainder: 'Reste à crédit',
      creditCustomer: 'Client',
      creditCustomerPlaceholder: 'Nom ou téléphone…',
      debtOwed: 'Créance ouverte',
      debtCollect: 'Encaisser',
      paymentKeyCash: 'F2',
      paymentKeyElectronic: 'F3',
      paymentKeyCredit: 'F5',
      paymentShortcutCashHint: 'F2 ou Ctrl+2',
      paymentShortcutElectronicHint: 'F3 ou Ctrl+3',
      paymentShortcutCreditHint: 'F5 ou Ctrl+4',
      amountPaid: 'Montant payé',
      exactAmount: 'Exact',
      totalToPay: 'Total à payer',
      change: 'Monnaie',
      draft: 'Brouillon',
      deliveryMode: 'Mode livraison',
      deliveryHint:
        'Envoie en cuisine (colonne Livraison) et enregistre un brouillon pour encaisser à la livraison.',
      deliveryPhone: 'Téléphone (optionnel)',
      deliveryPhonePlaceholder: 'Ex. 22 12 34 56',
      deliverySave: 'Créer livraison',
      processing: 'Traitement...',
      checkoutLoading: 'Chargement...',
      checkout: 'Encaisser',
      enterKey: 'Entrée',
      searchFocusHint: 'Ctrl+F ou F4',
      searchFocusKey: 'Ctrl+F',
      loadingProducts: 'Chargement des produits...',
      noProductsAvailable: 'Aucun produit disponible',
      emptyGridHint: 'Modifiez la catégorie ou recherchez un produit / code-barres.',
      emptyGridCta: 'Ouvrir la recherche',
      emptyCartHint: 'Scannez un code-barres ou recherchez un produit pour commencer.',
      emptyCartCta: 'Rechercher un produit',
      outOfStockShort: 'Rupture',
      addPurchase: 'Ajouter Achat',
      importExcel: 'Import Excel',
      stockLabel: 'Stock',
      draftsTitle: 'Brouillons de vente',
      drafts: 'Brouillons',
      scanBarcode: 'Scanner le code-barres',
      scan: 'Scanner',
      menuSectionsAria: 'Sections du menu',
      posCategoriesAria: 'Catégories POS',
      posToolsAria: 'Outils caisse',
      serviceModeEmporter: 'Emporter',
      serviceModeService: 'Service',
      tableFloorTitle: 'Tables',
      tableFloorHint: 'Choisissez une table pour ouvrir ou continuer une commande.',
      tableFloorEmpty: 'Aucune table active — ajoutez des tables dans Paramètres.',
      tableFree: 'Libre',
      tableOccupied: 'Occupée',
      tableActiveBadge: 'Table {{label}}',
      tableSaveTicket: 'Enregistrer',
      tableBackToFloor: 'Tables',
      tableCancelTicket: 'Annuler ticket',
      coversLabel: 'Couverts',
      coversShort: '{{count}} cov.',
      courseLabel: 'Service',
      course_entree: 'Entrée',
      course_plat: 'Plat',
      course_dessert: 'Dessert',
      course_boisson: 'Boisson',
      course_autre: 'Autre',
      kitchenSent: 'Cuisine',
      kitchenSentSuccess: '{{count}} ligne(s) envoyée(s)',
      kitchenSentParked: '{{count}} ligne(s) envoyée(s) — panier vidé, en attente cuisine',
      kitchenSentAjout: 'Ajout cuisine',
      kitchenSentAjoutDetail:
        'Ajout: {{count}} nouvelle(s) ligne(s) seulement — pas toute la commande',
      kitchenSendFailed: 'Envoi cuisine impossible — réessayez',
      kitchenNothingToSend: 'Cuisine',
      kitchenNothingToSendDetail: 'Rien de nouveau à envoyer',
      kitchenParkedAwaiting: 'Commande en cuisine — vous pouvez encaisser (Prêt optionnel)',
      kitchenParkedPayable: 'Cuisine: vous pouvez encaisser',
      kitchenLoadForPay: 'Charger pour encaisser',
      kitchenCheckoutAwaiting: 'En cuisine…',
      kitchenCheckoutSendFirst: 'Envoyer cuisine',
      kitchenStatus_sent: 'En cuisine',
      kitchenStatus_preparing: 'En prep.',
      kitchenStatus_ready: 'Prêt',
      kitchenStatus_served: 'Servi',
      kitchenSend: 'Envoyer cuisine',
      kitchenMarkReady: 'Prêt',
      kitchenMarkServed: 'Servi',
      kitchenOrders: 'Cuisine',
      kitchenOrdersTitle: 'Commandes cuisine',
      kitchenOrdersHint:
        'Commandes envoyées — chargez au panier seulement quand vous encaisserez. Table, Emporter et Livraison sont séparés.',
      kitchenOrdersOpen: 'Ouvrir commandes',
      kitchenOrdersEmpty: 'Aucune commande cuisine',
      kitchenOrdersSectionTable: 'Sur place (tables)',
      kitchenOrdersSectionEmporter: 'Emporter',
      kitchenOrdersSectionDelivery: 'Livraison',
      kitchenOrdersSectionEmpty: 'Rien ici',
      kitchenSoundOn: 'Son',
      kitchenSoundOff: 'Muet',
      kitchenSoundMute: 'Couper les sons cuisine',
      kitchenSoundUnmute: 'Activer les sons cuisine',
      kitchenReleaseSecondScreen: 'Partager 2ᵉ écran',
      kitchenReleaseSecondScreenTitle:
        'Affiche uniquement la cuisine sur le 2ᵉ moniteur (HDMI / écran sans fil) — pas tout le bureau',
      kitchenOrderChannelTable: 'Table',
      kitchenOrderChannelEmporter: 'Emporter',
      kitchenOrderChannelDelivery: 'Livraison',
      kitchenOrderTableTitle: 'Table {{label}}',
      kitchenOrderEmporterTitle: 'Emporter',
      kitchenOrderDeliveryTitle: 'Livraison',
      kitchenOrderDeliveryTitlePhone: 'Livraison · {{phone}}'
    },

    authPage: {
      ...authPageLoginFr,
      back: 'Retour',
      backToLogin: 'Retour à la connexion',
      forgotPasswordTitle: 'Mot de passe oublié',
      forgotPasswordSubtitleOffline: 'Réinitialisez votre mot de passe sans Internet — avec votre code gestionnaire ou NIF.',
      forgotPasswordSubtitle: 'Réinitialisez votre mot de passe sans Internet — avec votre code gestionnaire ou NIF.',
      forgotPasswordHeading: 'Réinitialisation hors ligne',
      forgotStepIdentify: '1. Identifiant',
      forgotStepVerify: '2. Vérification',
      forgotStepReset: '3. Nouveau mot de passe',
      forgotContinue: 'Continuer',
      forgotOfflineInfo: 'Fonctionne sans Internet. Les données sont enregistrées dans localStorage sur ce PC.',
      forgotAccountFound: 'Compte : {{name}}',
      identifierLabel: 'Nom d\'utilisateur ou e-mail',
      identifierPlaceholder: 'Identifiant utilisé à l\'inscription',
      verificationCodeLabel: 'Code gestionnaire ou NIF',
      verificationCodePlaceholder: 'Code défini à l\'inscription',
      verificationCodeHint: 'Saisissez le code gestionnaire (4 chiffres) ou le NIF fiscal enregistré lors de la création du compte.',
      verificationCodeRequired: 'Code gestionnaire ou NIF requis',
      invalidVerificationCode: 'Code gestionnaire ou NIF incorrect',
      accountNotFoundOffline: 'Aucun compte local avec cet identifiant',
      offlineResetSuccessNote: 'Mot de passe enregistré localement (localStorage + IndexedDB).',
      emailLabel: 'Adresse email',
      emailPlaceholder: 'Entrez votre adresse email',
      sendResetLink: 'Envoyer le lien de réinitialisation',
      resetLinkInfo: 'Un lien de réinitialisation sera envoyé à votre adresse email.',
      resetLinkInfo2: 'Cliquez sur le lien dans l\'email pour créer un nouveau mot de passe.',
      emailSentTitle: 'Email envoyé',
      emailSentMessage: 'Un lien de réinitialisation a été envoyé à votre adresse email.',
      emailSentCheck: 'Vérifiez votre boîte de réception et cliquez sur le lien pour réinitialiser votre mot de passe.',
      accountNotFound: 'Aucun compte trouvé avec cette adresse email',
      genericError: 'Une erreur est survenue. Veuillez réessayer.',
      passwordResetTitle: 'Réinitialisation du mot de passe',
      resetPasswordTitle: 'Nouveau mot de passe',
      resetPasswordSubtitle: 'Choisissez un mot de passe sécurisé pour {{email}}',
      resetPasswordHeading: 'Réinitialisation',
      newPasswordLabel: 'Nouveau mot de passe',
      newPasswordPlaceholder: 'Entrez le nouveau mot de passe',
      confirmPasswordLabel: 'Confirmer le mot de passe',
      confirmPasswordPlaceholder: 'Confirmez le mot de passe',
      savePassword: 'Enregistrer le mot de passe',
      passwordUpdatedTitle: 'Mot de passe mis à jour',
      passwordUpdatedMessage: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
      invalidResetLink: 'Lien de réinitialisation invalide.',
      invalidOrExpiredLink: 'Lien de réinitialisation invalide ou expiré',
      linkExpired: 'Ce lien a expiré. Demandez un nouveau lien.',
      passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      updatePasswordFailed: 'Impossible de mettre à jour le mot de passe',
      resetLinkSentTo: 'Lien de réinitialisation envoyé à {{email}}:\n{{link}}'
    },

    printerPicker: {
      title: 'Sélectionner une imprimante',
      currentPrinter: 'Imprimante actuelle',
      loading: 'Chargement...',
      loadError: 'Impossible de charger les imprimantes',
      noPrinters: 'Aucune imprimante détectée. Vérifiez qu\'Electron est lancé.',
      cancel: 'Annuler',
      confirm: 'Confirmer'
    },

    paginationPage: {
      previous: 'Précédent',
      next: 'Suivant',
      pageOf: 'Page {{current}} sur {{total}}',
      showing: 'Affichage de {{start}} à {{end}} sur {{total}} résultats',
      showLabel: 'Afficher :',
      firstPage: 'Première page',
      previousPage: 'Page précédente',
      nextPage: 'Page suivante',
      lastPage: 'Dernière page'
    },

    managerDashboard: managerDashboardFr,
    workerSessionManager: workerSessionManagerFr,
    paymentReportPage: paymentReportPageFr,
    stockPage: stockPageFr,
    catalogPage: catalogPageFr,
    settingsPage: settingsPageFr,
    employeesPage: employeesPageFr,
    inventoryPage: inventoryPageFr,
    priceLabels: priceLabelsFr,
    addProductModal: addProductModalFr,
    addOrderModal: addOrderModalFr,
    addPurchaseModal: addPurchaseModalFr,
    editProductModal: editProductModalFr,
    orderConfirmationModal: orderConfirmationModalFr,
    achatVsVenteReport: achatVsVenteReportFr,
    foodCostReport: foodCostReportFr,
    adminDashboard: adminDashboardFr,
    registerPage: registerPageFr,
    productValidationModal: productValidationModalFr,
    codeEntryModal: codeEntryModalFr,
    salesDetailsModal: salesDetailsModalFr,
    editOrderModal: editOrderModalFr,
    dashboardReceiptModal: dashboardReceiptModalFr,
    ordersExcelImportModal: ordersExcelImportModalFr,
    posDashboard: posDashboardFr,
    smartInvoiceDisplay: smartInvoiceDisplayFr,
    lotSelectionModal: lotSelectionModalFr,
    editPurchaseModal: editPurchaseModalFr,
    layoutShell: layoutShellFr,
    addCustomerModal: addCustomerModalFr,
    draftsModal: draftsModalFr,
    fastImportModal: fastImportModalFr,
    addSupplierModal: addSupplierModalFr,
    datePicker: datePickerFr,
    excelImportModal: excelImportModalFr,
    paymentManagementPage: paymentManagementPageFr,
    orderDetailsModal: orderDetailsModalFr,
    exportPrintButton: exportPrintButtonFr,
    virtualizedProductRow: virtualizedProductRowFr,
    merchantReceiptModal: merchantReceiptModalFr,
    confirmDialog: confirmDialogFr,
    ecartModal: ecartModalFr,
    dailyClosingHistoryModal: dailyClosingHistoryModalFr,
    periodClosingHistoryModal: periodClosingHistoryModalFr,
    loadingOverlay: loadingOverlayFr,
    notificationCenter: notificationCenterFr,
    newCashRegisterModal: newCashRegisterModalFr,
    workerDashboardModal: workerDashboardModalFr,
    excelImportAchatModal: excelImportAchatModalFr,
    barcodeScanner: barcodeScannerFr,
    languageSwitcher: languageSwitcherFr,
    offlineIndicator: offlineIndicatorFr,
    storageSafeModeBanner: storageSafeModeBannerFr,
    inventoryLedgerSafeMode: inventoryLedgerSafeModeFr,
    conditionalRoutes: conditionalRoutesFr,
    storageBootstrap: storageBootstrapFr,
    tableCommon: tableCommonFr,
    pharmacyLotManager: pharmacyLotManagerFr,
    printServicePage: printServicePageFr,
    barcodeAutoLinkModal: barcodeAutoLinkModalFr,
    restaurantPage: restaurantPageFr,
    cuisinePage: cuisinePageFr,
    pharmacyDashboard: pharmacyDashboardFr,
    paymentModal: paymentModalFr,
    invoiceManagementModal: invoiceManagementModalFr
  },

  ar: {
    // Navigation
    dashboard: 'لوحة التحكم',
    inventory: 'المنتجات',
    stock: 'المخزون',
    stockWrite: 'المخزون — التعديل (النقل، الدفعات)',
    sales: 'المبيعات',
    voidSales: 'المبيعات — إلغاء / ستورنو',
    purchases: 'المشتريات',
    orders: 'الطلبات',
    suppliers: 'الموردون',
    customers: 'العملاء',
    reports: 'التقارير',
    payments: 'دفع الفواتير',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',

    // Common Actions
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    close: 'إغلاق',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    import: 'استيراد',
    view: 'عرض',
    update: 'تحديث',
    create: 'إنشاء',
    remove: 'إزالة',
    select: 'اختيار',
    confirm: 'تأكيد',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    clear: 'مسح',
    pay: 'دفع',
    autoUpdate: 'تحديث تلقائي',
    openCalendar: 'فتح التقويم',
    previousMonth: 'الشهر السابق',
    nextMonth: 'الشهر التالي',
    datePlaceholder: 'يوم/شهر/سنة',
    invalidDate: 'تاريخ غير صحيح',
    dateBeforeMinimum: 'التاريخ سابق للحد الأدنى المسموح',
    dateAfterMaximum: 'التاريخ لاحق للحد الأقصى المسموح',
    credit: 'الائتمان',
    noInvoicesFound: 'لا توجد فواتير',
    createInvoices: 'إنشاء الفواتير',
    addPayment: 'إضافة دفعة',
    amount: 'المبلغ',

    // Form Labels
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    quantity: 'الكمية',
    price: 'السعر',
    total: 'المجموع',
    date: 'التاريخ',
    status: 'الحالة',
    for: 'ل',
    order: 'الطلب',
    purchase: 'الشراء',
    category: 'الفئة',
    subcategory: 'الفئة الفرعية',
    type: 'النوع',
    supplier: 'المورد',
    customer: 'العميل',
    product: 'المنتج',
    description: 'الوصف',
    notes: 'الملاحظات',
    unit: 'الوحدة',
    sku: 'رمز المنتج',
    value: 'القيمة',
    actions: 'الإجراءات',

    // Orders page (الطلبات)
    ordersPage: {
      searchTypeLabel: 'نوع البحث',
      searchReceipt: 'الاسم أو الرقم',
      searchSupplier: 'المورد',
      searchDate: 'تاريخ محدد',
      searchPeriod: 'الفترة',
      searchReceiptPlaceholder: 'أدخل الاسم أو الرقم (مثال: ORD69035، أحمد، منتج)',
      dateFrom: 'من التاريخ',
      dateTo: 'إلى التاريخ',
      orderStatusFilter: 'حالة الطلب',
      allStatuses: 'كل الحالات',
      statusEnRoute: 'في الطريق',
      statusDelivered: 'تم التسليم',
      statusCancelled: 'ملغي',
      newOrder: 'طلب جديد',
      importExcel: 'استيراد Excel',
      bulkDeleteVerb: 'حذف',
      bulkDeleteNoun: 'طلبات',
      confirmBulkDeleteTitle: 'تأكيد الحذف الجماعي',
      bulkDeleteMsgPrefix: 'هل أنت متأكد من حذف',
      bulkDeleteMsgSuffix: 'طلبات؟ لا يمكن التراجع عن هذا الإجراء.',
      ordersSectionTitle: 'الطلبات',
      selectedOrdersSuffix: 'طلبات',
      emptyNoOrders: 'لا توجد طلبات مضافة بعد. انقر على « طلب جديد » للبدء.',
      emptyNoMatch: 'لا توجد طلبات مطابقة لمعايير البحث الخاصة بك.',
      productUnknown: 'منتج غير معروف',
      unknownSupplier: 'مورد غير معروف',
      actionConfirmDelivery: 'تأكيد التوصيل',
      actionViewDetails: 'عرض التفاصيل',
      actionEditOrder: 'تعديل الطلب',
      actionDeleteOrder: 'حذف الطلب',
      deleteOrderTitle: 'تأكيد الحذف',
      deleteOrderMessage: 'هل أنت متأكد من حذف هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء.',
      toastProductAdded: 'تمت إضافة المنتج بنجاح',
      toastSupplierAdded: 'تمت إضافة المورد بنجاح',
      toastOrderAdded: 'تمت إضافة الطلب بنجاح',
      toastOrderUpdated: 'تم تحديث الطلب بنجاح',
      toastOrderDeleted: 'تم حذف الطلب بنجاح',
      toastOrderCancelled: 'تم إلغاء الطلب بنجاح',
      toastOrderConfirmedStock: 'تم تأكيد الطلب وإضافته إلى المشتريات والمخزون',
      toastOrderConvertError: 'حدث خطأ أثناء تحويل الطلب إلى شراء',
      toastImportSuccess: 'تم استيراد الطلبات بنجاح',
      reportTitlePrefix: 'تقرير الطلبات',
      summaryTotalGroups: 'إجمالي الطلبات',
      summaryEnRoute: 'الطلبات في الطريق',
      summaryDelivered: 'الطلبات المُسلّمة',
      summaryCancelled: 'الطلبات الملغاة',
      bulkDeleteToastFr: 'commandes supprimées avec succès',
      bulkDeleteToastArStart: 'تم حذف',
      bulkDeleteToastArEnd: 'طلبات بنجاح',
      bulkDeleteToast: 'تم حذف {{count}} طلبات بنجاح',
      export: {
        orderNum: 'رقم الطلب',
        date: 'التاريخ',
        supplier: 'المورد',
        product: 'المنتج',
        quantity: 'الكمية',
        unitPrice: 'السعر للوحدة',
        total: 'الإجمالي',
        expectedDelivery: 'التسليم المتوقع',
        status: 'الحالة'
      },
      tableOrderDate: 'تاريخ الطلب',
      tableOrderId: 'رقم الطلب #'
    },

    // Purchases page (المشتريات)
    purchasesPage: {
      searchTypeLabel: 'نوع البحث',
      searchReceipt: 'رقم الشراء أو اسم المورد',
      searchSupplier: 'المورد',
      searchDate: 'تاريخ محدد',
      searchPeriod: 'فترة زمنية',
      searchReceiptPlaceholder: 'أدخل رقم الشراء أو اسم المورد (مثال: PUR69035، أحمد)',
      searchSupplierPlaceholder: 'اسم المورد (مثال: أحمد، شركة ABC)',
      dateFrom: 'من تاريخ',
      dateTo: 'إلى تاريخ',
      clearSearch: 'مسح البحث',
      newPurchase: 'شراء جديد',
      bulkDeleteVerb: 'حذف',
      bulkDeleteNoun: 'شراء',
      bulkDeleteMsgPrefix: 'هل أنت متأكد من حذف',
      bulkDeleteMsgSuffix: ' شراء؟ سيتم إلغاء تأثير هذه المشتريات على المخزون. لا يمكن التراجع عن هذا الإجراء.',
      purchasesSectionTitle: 'المشتريات',
      selectedPurchasesSuffix: 'شراء محدد',
      emptyNoPurchases: 'لم يتم إضافة أي شراء بعد. انقر على « شراء جديد » للبدء.',
      emptyNoMatch: 'لا يوجد شراء يتطابق مع معايير البحث الخاصة بك.',
      productUnknown: 'منتج غير معروف',
      actionEditPurchase: 'تعديل الشراء',
      actionDeletePurchase: 'حذف الشراء',
      actionViewDetails: 'عرض التفاصيل',
      viewPurchaseTitle: 'تفاصيل الشراء',
      viewPurchaseId: 'رقم الشراء',
      viewDate: 'التاريخ',
      viewDeliveryDate: 'تاريخ التسليم',
      viewTotalAmount: 'المبلغ الإجمالي',
      viewSupplierSection: 'معلومات المورد',
      viewSupplierName: 'الاسم',
      viewSupplierCompany: 'الشركة',
      viewSupplierEmail: 'البريد الإلكتروني',
      viewSupplierPhone: 'الهاتف',
      viewSupplierNotFound: 'معلومات المورد غير موجودة',
      viewProductsTitle: 'المنتجات',
      viewColBoxes: 'صناديق',
      viewColBarcode: 'الباركود',
      viewColExpiration: 'انتهاء الصلاحية',
      viewSummaryItems: 'إجمالي العناصر',
      viewSummaryAmount: 'المبلغ الإجمالي',
      deletePurchaseTitle: 'تأكيد الإلغاء',
      deletePurchaseMessage: 'إلغاء هذا الشراء يعلّم الأسطر والفاتورة غير المدفوعة كملغاة، ويعكس المخزون عبر حركات المخزون ويحدّث الجرد. السجلات تبقى للمراجعة.',
      toastPurchaseDeleted: 'تم حذف الشراء بنجاح',
      toastPurchaseVoided: 'تم إلغاء الشراء',
      toastPurchaseVoidedDetail: 'تم إلغاء الشراء — تم تحديث المخزون وفاتورة المورد.',
      alreadyVoided: 'هذا الشراء ملغى مسبقاً.',
      toastPurchaseAndInvoiceDeleted: 'تم حذف الشراء واللوتات والفاتورة — تم تحديث المخزون.',
      deleteBlockedPaidInvoice: 'تعذّر الحذف — الفاتورة المرتبطة تحتوي على مدفوعات.',
      bulkDeleteToastFr: 'achats supprimés avec succès',
      bulkDeleteToastArStart: 'تم حذف',
      bulkDeleteToastArEnd: 'شراء بنجاح',
      bulkDeleteToast: 'تم حذف {{count}} شراء بنجاح',
      saveErrorTitle: 'خطأ في الحفظ',
      saveFailedMessage: 'لم يتم حفظ الشراء — أعد المحاولة',
      invoiceCreated: 'تم إنشاء الفاتورة',
      invoiceErrorTitle: 'خطأ في الفاتورة',
      importExcelTitle: 'استيراد من Excel',
      importExcelLabel: 'استيراد Excel',
      scanInvoiceLabel: 'ملف فاتورة',
      scanInvoiceTitle: 'إضافة فاتورة للطابور (خلفية، بدون تعطيل)',
      scanInvoiceQueued: 'الفاتورة في الطابور — معالجة في الخلفية',
      scanInvoiceDone: 'انتهى التحليل — مراجعة يدوية مطلوبة ({{file}})',
      scanInvoiceError: 'تعذر إضافة الفاتورة للطابور',
      scanInvoiceTooLarge: 'الملف كبير جداً (حد أقصى 8 ميجا)',
      exportPortableLabel: 'تصدير قابل للاستيراد',
      exportPortableTitle: 'تصدير المشتريات (Excel + JSON مع روابط الصور)',
      exportPortableSuccess: 'التصدير جاهز — أعد الاستيراد عبر استيراد Excel',
      exportPortableEmpty: 'لا توجد مشتريات للتصدير',
      exportPortableFailed: 'فشل التصدير',
      importSuccessTitle: 'تم الاستيراد بنجاح',
      importSuccessMessage: 'تم تحديث قائمة المشتريات',
      deleteFailed: 'فشل الحذف',
      reportTitlePrefix: 'تقرير المشتريات',
      summaryTotalPurchases: 'إجمالي المشتريات',
      summaryTotalAmount: 'المبلغ الإجمالي',
      summaryThisMonth: 'مشتريات هذا الشهر',
      analyticsTotalPurchases: 'إجمالي المشتريات',
      analyticsPurchasesUnit: 'شراء',
      analyticsTotalAmount: 'إجمالي المبلغ',
      analyticsSpent: 'مُنفق',
      analyticsAvgValue: 'متوسط القيمة',
      analyticsPerPurchase: 'لكل شراء',
      analyticsTopSupplier: 'أفضل مورد',
      analyticsNotAvailable: 'غير محدد',
      loadingData: 'جاري تحميل البيانات…',
      tablePurchaseId: 'شراء #',
      tableUnitPrice: 'السعر الوحدة',
      tableItemsCount: 'المنتجات',
      tablePurchaseTotal: 'إجمالي الشراء',
      tableClickHint: 'انقر لعرض المنتجات',
      viewColSellingPrice: 'سعر البيع',
      tableDeliveryDate: 'تاريخ التسليم',
      tableExpirationDate: 'تاريخ انتهاء الصلاحية',
      tableLocation: 'الموقع',
      export: {
        purchaseNum: 'رقم الشراء',
        date: 'التاريخ',
        supplier: 'المورد',
        product: 'المنتج',
        quantity: 'الكمية',
        unitPrice: 'سعر الوحدة',
        total: 'المجموع',
        deliveryDate: 'تاريخ التسليم',
        expirationDate: 'تاريخ انتهاء الصلاحية',
        location: 'الموقع',
        imageUrl: 'رابط الصورة'
      }
    },

    expensesPage: {
      reportTitlePrefix: 'تقرير المصروفات',
      summaryTotal: 'إجمالي المصروفات',
      summaryCustoms: 'الجمرك',
      summaryTransport: 'النقل',
      paymentCashLabel: 'نقداً',
      confirmOverAmount: 'المبلغ ({{amount}}) أكبر من المتاح ({{available}}). المتابعة ستسجل تمويلاً خارجياً (رصيد سالب).{{suffix}}',
      overAmountSuggestion: ' الاقتراح: {{method}}',
      errorOverAmount: 'المبلغ أكبر من الرصيد المتاح لهذه الطريقة ({{available}}). {{tail}}',
      overAmountSuggestionTail: 'اقتراح: {{method}}.',
      overAmountNegativeHint: 'سيظهر الفرق كتمويل خارجي (سالب) في التقرير.',
      confirmExpenseSetupPhase: 'لا مبيعات بعد: تُسجَّل المصروفات كتمويل خارجي — {{amount}}',
      confirmExpenseCrossMethod: 'المبلغ ({{amount}}) أكبر من المتاح على الطريقة المختارة. التوزيع: {{split}}{{external}}',
      confirmExpenseExternalAddon: '، خارجي: {{amount}}',
      fundingRegisterLabel: 'من الصندوق',
      fundingExternalLabel: 'خارجي',
      errCashRegisterExpense: 'فشل تحديث الصندوق — لم تُسجَّل المصروفات',
      export: {
        date: 'التاريخ',
        category: 'الفئة',
        description: 'الوصف',
        amount: 'المبلغ',
        paymentMethod: 'طريقة الدفع'
      }
    },

    suppliersPage: {
      deleteSupplierTitle: 'تأكيد الحذف',
      deleteSupplierMessage: 'هل أنت متأكد من حذف هذا المورد؟ لا يمكن التراجع عن هذا الإجراء.',
      editSupplierTitle: 'تعديل المورد',
      supplierInfoSection: 'معلومات المورد',
      company: 'الشركة',
      updateSupplier: 'تحديث المورد',
      selectStatus: 'اختر الحالة',
      searchTypeLabel: 'نوع البحث',
      searchNameOrPhone: 'الاسم أو رقم الهاتف',
      searchJoinDate: 'تاريخ التسجيل',
      searchJoinPeriod: 'فترة التسجيل',
      nameSearchPlaceholder: 'أدخل اسم المورد أو رقم الهاتف',
      dateFrom: 'من تاريخ',
      dateTo: 'إلى تاريخ',
      addSupplier: 'إضافة مورد',
      suppliersTitle: 'الموردون',
      totalSuppliersCount: 'المجموع: {{count}} مورد',
      tableSupplierId: 'معرف المورد',
      tableName: 'الاسم',
      tableCompany: 'الشركة',
      tableEmail: 'البريد الإلكتروني',
      tablePhone: 'الهاتف',
      tableAddress: 'العنوان',
      tableStatus: 'الحالة',
      tableJoinDate: 'تاريخ الانضمام',
      tableActions: 'الإجراءات',
      emptyNoSuppliers: 'لم يتم إضافة أي مورد بعد. انقر على «إضافة مورد» للبدء.',
      emptyNoMatch: 'لا يوجد مورد يتطابق مع معايير البحث الخاصة بك.',
      actionViewPurchases: 'عرض المشتريات',
      actionEditSupplier: 'تعديل المورد',
      actionDeleteSupplier: 'حذف المورد',
      viewSupplierTitle: 'تفاصيل المورد',
      labelCompanyEmpty: 'الشركة غير محددة',
      contactSection: 'بيانات الاتصال',
      labelPhoneShort: 'الهاتف',
      labelEmailShort: 'البريد',
      labelAddressShort: 'العنوان',
      noContactInfo: 'لا توجد بيانات اتصال',
      purchasesPeriodAria: 'تصفية المشتريات حسب الفترة',
      labelCompany: 'الشركة:',
      labelEmail: 'البريد الإلكتروني:',
      labelPhone: 'الهاتف:',
      labelAddress: 'العنوان:',
      labelStatus: 'الحالة:',
      labelJoinDate: 'تاريخ الانضمام:',
      purchasesTitle: 'المشتريات',
      periodAll: 'كل الوقت',
      periodToday: 'اليوم',
      periodWeek: 'هذا الأسبوع',
      periodMonth: 'هذا الشهر',
      periodQuarter: 'هذا الربع',
      periodYear: 'هذه السنة',
      purchaseColProduct: 'المنتج',
      purchaseColQty: 'الكمية',
      purchaseColUnitPrice: 'سعر الوحدة',
      purchaseColTotal: 'المجموع',
      purchaseColDeliveryDate: 'تاريخ التسليم',
      noPurchasesForSupplier: 'لا توجد مشتريات لهذا المورد',
      statusActive: 'نشط',
      statusInactive: 'غير نشط',
      statusPending: 'معلق',
      reportTitlePrefix: 'تقرير الموردين',
      summaryTotalSuppliers: 'إجمالي الموردين',
      summaryActiveSuppliers: 'موردون نشطون',
      export: {
        supplierId: 'معرف المورد',
        name: 'الاسم',
        company: 'الشركة',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        address: 'العنوان',
        status: 'الحالة',
        date: 'التاريخ'
      }
    },

    customersPage: {
      searchTypeLabel: 'نوع البحث',
      searchNameOrPhone: 'الاسم أو الهاتف',
      searchJoinDate: 'تاريخ التسجيل',
      searchJoinPeriod: 'فترة التسجيل',
      clearSearch: 'مسح البحث',
      nameSearchPlaceholder: 'أدخل الاسم أو رقم الهاتف (مثال: أحمد، 22234567)',
      newCustomer: 'عميل جديد',
      salesModalTitle: 'مبيعات العميل',
      salesModalTitleWithName: 'مبيعات — {{name}}',
      customerLabel: 'العميل:',
      noEmail: 'لا يوجد بريد إلكتروني',
      filterByPeriod: 'تصفية حسب الفترة:',
      periodAll: 'كل الوقت',
      periodThisMonth: 'هذا الشهر',
      periodLast3Months: 'آخر 3 أشهر',
      periodLast6Months: 'آخر 6 أشهر',
      periodLastYear: 'السنة الماضية',
      errorMissingCustomerId: 'خطأ: معرف العميل مفقود',
      noSalesForCustomer: 'لا توجد مبيعات مسجلة لهذا العميل حالياً.',
      salesTableOrderId: 'معرف الطلب',
      salesTableDate: 'التاريخ',
      salesTableProduct: 'المنتج',
      salesTableQuantity: 'الكمية',
      salesTableUnitPrice: 'سعر البيع',
      salesTableTotal: 'المجموع',
      salesTableStatus: 'الحالة',
      undefinedShort: 'غير محدد',
      customersTitle: 'العملاء',
      totalCustomersCount: 'الإجمالي: {{count}} عميل',
      tableCustomerId: 'معرف العميل',
      tableName: 'الاسم',
      tableEmail: 'البريد الإلكتروني',
      tablePhone: 'الهاتف',
      tableAddress: 'العنوان',
      tableTotalOrders: 'إجمالي الطلبات',
      tableTotalSpent: 'إجمالي المنفق',
      tableDebt: 'الدين المستحق',
      tableStatus: 'الحالة',
      tableNotes: 'الملاحظات',
      tableJoinDate: 'تاريخ الانضمام',
      tableActions: 'الإجراءات',
      emptyNoCustomers: 'لا يوجد عملاء بعد. انقر على «عميل جديد» للبدء.',
      emptyNoMatch: 'لا يوجد عميل يطابق معايير البحث.',
      notProvided: 'غير محدد',
      noDebt: 'لا يوجد',
      noNotes: 'لا توجد ملاحظات',
      actionViewSales: 'عرض المبيعات',
      actionEditCustomer: 'تعديل العميل',
      actionCollectDebt: 'تحصيل الدين',
      debtPaymentTitle: 'تحصيل دين العميل',
      debtPaymentRemaining: 'المتبقي',
      debtPaymentAmount: 'المبلغ المستلم',
      debtPaymentMethod: 'طريقة الدفع',
      debtPaymentCash: 'نقداً',
      debtPaymentElectronic: 'إلكتروني',
      debtPaymentProvider: 'المزوّد',
      debtPaymentNote: 'ملاحظة (اختياري)',
      debtPaymentNotePlaceholder: 'مرجع، إيصال…',
      debtPaymentConfirm: 'تسجيل الدفع',
      debtPaymentSaving: 'جارٍ الحفظ…',
      debtPaymentInvalidAmount: 'مبلغ غير صالح',
      debtPaymentExceedsRemaining: 'المبلغ يتجاوز الدين المتبقي',
      debtPaymentNoDebt: 'لا يوجد دين مفتوح لهذا العميل',
      debtPaymentFailed: 'فشل الدفع ({{error}})',
      debtPaymentSuccess: 'تم تسجيل الدفع: {{amount}}',
      debtPaymentHistory: 'سجل التحصيلات',
      debtPaymentHistoryEmpty: 'لا توجد تحصيلات مسجّلة لهذا العميل',
      editCustomerTitle: 'تعديل العميل',
      customerInfoSection: 'معلومات العميل',
      updateCustomer: 'تحديث العميل',
      optionalEmail: 'البريد الإلكتروني (اختياري)',
      optionalPhone: 'الهاتف (اختياري)',
      optionalAddress: 'العنوان (اختياري)',
      optionalNotes: 'ملاحظات عن العميل (اختياري)',
      statusActive: 'نشط',
      statusInactive: 'غير نشط',
      statusPending: 'معلق',
      statusVip: 'مميز',
      reportTitlePrefix: 'تقرير العملاء',
      summaryTotalCustomers: 'إجمالي العملاء',
      summaryActiveCustomers: 'العملاء النشطون',
      summaryTotalDebts: 'إجمالي الديون',
      dateFrom: 'من تاريخ',
      dateTo: 'إلى تاريخ',
      export: {
        customerId: 'معرف العميل',
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        address: 'العنوان',
        orders: 'الطلبات',
        spent: 'المنفق',
        debt: 'الدين',
        status: 'الحالة',
        date: 'التاريخ'
      }
    },

    salesPage: {
      pageTitle: 'المبيعات',
      searchTypeLabel: 'نوع البحث',
      searchReceipt: 'رقم البيع أو اسم العميل',
      searchDatePrecise: 'تاريخ محدد',
      searchPeriod: 'فترة زمنية',
      searchWeek: 'أسبوع',
      searchMonth: 'شهر',
      searchThreeMonths: 'ثلاثة أشهر',
      searchMonthYear: 'شهر وسنة',
      dateFilterLabel: 'التاريخ',
      dateFilterAll: 'الكل',
      clearSearch: 'مسح البحث',
      searchFieldLabel: 'البحث',
      searchPlaceholder: 'أدخل رقم البيع أو اسم العميل (مثال: VENTE900375، أحمد)',
      dateFrom: 'من تاريخ',
      dateTo: 'إلى تاريخ',
      paymentFilterLabel: 'الدفع',
      paymentFilterAll: 'الكل',
      paymentFilterCash: 'نقداً',
      paymentFilterElectronic: 'إلكتروني',
      paymentFilterCredit: 'الذمم',
      deliveryFilterLabel: 'التوصيل',
      deliveryFilterAll: 'الكل',
      deliveryFilterDelivery: 'توصيل',
      deliveryFilterNonDelivery: 'بدون توصيل',
      summaryCreancesUnpaid: 'الذمم (غير مدفوع)',
      actionsColumn: 'الإجراءات',
      viewLabel: 'عرض',
      viewTable: 'جدول',
      viewReport: 'تقرير',
      viewExport: 'تصدير',
      bulkDeleteCount: 'حذف {{count}} بيع',
      analyticsTotalSales: 'إجمالي المبيعات',
      analyticsSalesUnit: 'بيع',
      analyticsRevenue: 'إجمالي الإيرادات',
      analyticsReceived: 'مُستلم',
      analyticsAvgOrder: 'متوسط قيمة الطلب',
      analyticsPerSale: 'لكل بيع',
      analyticsTopCustomer: 'أفضل عميل',
      loadingData: 'جاري تحميل البيانات…',
      notAvailable: 'غير محدد',
      customerUnspecified: 'غير محدد',
      statusCompleted: 'مكتمل',
      statusPending: 'في الانتظار',
      statusCancelled: 'ملغي',
      statusModified: 'معدّل',
      listTitle: 'قائمة المبيعات',
      tableReceipt: 'رقم الإيصال',
      tableDate: 'التاريخ',
      tableTime: 'الوقت',
      tableClient: 'العميل',
      tableProducts: 'المنتجات',
      tableAmount: 'المبلغ',
      tableStatus: 'الحالة',
      tablePaymentMethod: 'الدفع',
      tableActions: 'الإجراءات',
      deliverySaleBadge: 'توصيل',
      productCountSuffix: 'منتج',
      actionViewDetails: 'عرض التفاصيل',
      actionMerchantReceipt: 'عرض فاتورة التاجر',
      actionDeleteSale: 'حذف البيع',
      emptyTitle: 'لا توجد مبيعات',
      emptyDescription: 'لم يتم العثور على مبيعات تطابق المعايير المحددة',
      reportTitlePrefix: 'تقرير المبيعات',
      summaryTotalSales: 'إجمالي المبيعات',
      summaryTotalRevenue: 'إجمالي الإيرادات',
      summaryCompleted: 'مبيعات مكتملة',
      exportDataTitle: 'تصدير البيانات',
      exportChooseFormat: 'اختر تنسيق التصدير',
      deleteConfirmTitle: 'تأكيد الحذف',
      deleteConfirmMessage: 'هل أنت متأكد من حذف البيع رقم {{orderId}}؟ لا يمكن التراجع عن هذا الإجراء.',
      bulkDeleteConfirmTitle: 'تأكيد الحذف الجماعي',
      bulkDeleteConfirmMessage: 'هل أنت متأكد من حذف {{count}} بيع؟ لا يمكن التراجع عن هذا الإجراء.',
      deleteFailed: 'فشل حذف البيع',
      bulkDeleteFailed: 'فشل الحذف الجماعي',
      tableWorker: 'العامل',
      restaurantMenuPieces: 'قطعة قائمة',
      export: {
        receiptNum: 'رقم الإيصال',
        date: 'التاريخ',
        time: 'الوقت',
        client: 'العميل',
        products: 'المنتجات',
        amount: 'المبلغ',
        paymentMethod: 'طريقة الدفع'
      }
    },

    reportsPage: {
      pageTitle: 'التقارير والتحليلات',
      cacheLoading: 'جاري تحميل البيانات...',
      cacheReady: 'البيانات محدثة ومحسنة',
      calculationsLoading: 'جاري حساب التغطية وإعادة الطلب…',
      calculationsError: 'خطأ في حساب التقارير',
      sectionStockMovement: 'تغطية المخزون',
      sectionExpirationAlerts: 'تنبيهات انتهاء الصلاحية',
      sectionExpiredProducts: 'المنتجات منتهية الصلاحية',
      sectionBalanceSheet: 'ملخص المحل',
      sectionFoodCost: 'تكلفة الطعام',
      stockMovementTitle: 'التغطية وإعادة الطلب',
      stockCoverageHint:
        'عرض التغطية وإعادة الطلب (مشترى/مباع، مخزون). لسجل الحركات: المخزون → سجل الحركات.',
      linkLedgerHistory: 'فتح سجل الحركات',
      reorderBacktestTitle: 'متابعة إعادة الطلب (30 يوم)',
      reorderBacktestSummary:
        '{{needing}} لإعادة الطلب · مشتريات {{hitPct}}% · تغطية الكمية {{fillPct}}% · ناقص الطلب {{under}} · نافذة {{days}} يوم',
      managerInsightsTitle: 'رؤى المدير',
      insightClickHint: 'انقر للفتح',
      insightReorderUrgent: '{{count}} منتج لإعادة الطلب — الأولوية: {{names}}',
      insightReorderUrgentAction: 'إنشاء طلب شراء أو التحقق من المشتريات الجارية',
      insightTransfer: '{{count}} نقل مفيد — {{names}}',
      insightTransferAction: 'النقل من المواقع الأخرى إلى الرئيسي',
      insightExpiry: '{{count}} تنبيه انتهاء صلاحية ({{urgent}} عاجل)',
      insightExpiryAction: 'فتح تنبيهات الانتهاء / تدوير FEFO',
      insightSlowMovers: '{{count}} حركة بطيئة — {{names}}',
      insightSlowMoversAction: 'عرض ترويجي أو نقل أو إيقاف الشراء',
      insightLowCoverage: '{{count}} تغطية منخفضة — {{names}}',
      insightLowCoverageAction: 'مراقبة نفاد المخزون الوشيك',
      insightBacktestGap:
        'متابعة إعادة الطلب ضعيفة: {{hitPct}}% مشتريات من {{needing}} اقتراح ({{under}} ناقص الطلب، {{days}} يوم)',
      insightBacktestGapAction: 'مقارنة الاقتراحات بأوامر الشراء الأخيرة',
      linkAchatVsVente: 'عرض الشراء مقابل البيع',
      searchProductsPlaceholder: 'البحث عن المنتجات...',
      sortUpdatedAt: 'آخر تحديث',
      sortProduct: 'المنتج',
      sortPurchased: 'مشترى',
      sortSold: 'مباع',
      sortInStock: 'في المخزون',
      sortAsc: 'تصاعدي',
      sortDesc: 'تنازلي',
      perfNormal: 'عادي',
      perfBest: 'الأفضل',
      perfWorst: 'الأسوأ',
      periodChoose: 'اختر الفترة',
      periodLastYear: 'آخر سنة',
      periodLast6Months: 'آخر 6 أشهر',
      periodLast3Months: 'آخر 3 أشهر',
      periodDatePrecise: 'تاريخ محدد',
      periodRange: 'فترة زمنية',
      datePrecise: 'تاريخ محدد',
      dateFrom: 'من تاريخ',
      dateTo: 'إلى تاريخ',
      recordsCleared: 'تم مسح {{count}} سجل محذوف',
      recordsClearError: 'خطأ في مسح السجلات المحذوفة',
      stockReportCardTitle: 'تقرير حركة المخزون',
      stockColProduct: 'اسم المنتج',
      stockColPurchased: 'مشترى',
      stockColSold: 'مباع',
      stockColInStockDetail: 'في المخزون / تفصيل',
      stockColAvgSales: 'متوسط المبيعات اليومية (رئيسي)',
      stockColCoverage: 'التغطية (أيام)',
      stockColReorder: 'كمية إعادة الطلب المقترحة',
      stockColTransfer: 'كمية النقل المقترحة',
      stockColConservation: 'نوع الحفظ',
      stockTotal: 'المجموع',
      stockStartup: 'فترة بداية',
      stockTarget: 'هدف',
      summaryTotalProducts: 'إجمالي المنتجات',
      summaryLowCoverage: 'منتجات بتغطية منخفضة',
      summaryToReorder: 'منتجات لإعادة الطلب',
      expirationSectionHeading: 'تنبيه انتهاء صلاحية المنتج (حسب نوع الحفظ)',
      expirationCardTitle: 'تنبيه انتهاء صلاحية المنتج',
      expColProduct: 'المنتج',
      expColQtyRemaining: 'الكمية المتبقية',
      expColExpiry: 'تاريخ انتهاء الصلاحية',
      expColDaysRemaining: 'الأيام المتبقية',
      expColLocation: 'الموقع',
      expColLot: 'رقم اللوت',
      expColConservationType: 'نوع الحفظ',
      expColActionRequired: 'الإجراء المطلوب',
      conservationPERISSABLE: 'قابل للتلف',
      conservationCOURTE: 'قصيرة',
      conservationMOYENNE: 'متوسطة',
      conservationLONGUE: 'طويلة',
      conservationSANS_DATE: 'بدون تاريخ',
      conservationNORMAL: 'عادي',
      actionURGENT: 'عاجل',
      actionATTENTION: 'انتباه',
      actionSURVEILLER: 'مراقبة',
      locPrincipal: 'رئيسي',
      locEntrepot: 'مستودع',
      locBoutique: 'متجر',
      locMagasin: 'محل',
      locOther: 'أخرى',
      expiredCardTitle: 'المنتجات منتهية الصلاحية',
      expiredColProduct: 'المنتج',
      expiredColQuantity: 'الكمية',
      expiredColExpiration: 'تاريخ انتهاء الصلاحية',
      expiredColPurchase: 'تاريخ الشراء',
      expiredColLocation: 'الموقع',
      expiredColStatus: 'الحالة',
      expiredColActions: 'إجراءات',
      expiredProcess: 'معالجة المنتجات',
      expiredProcessTitle: 'معالجة المنتجات منتهية الصلاحية',
      expiredProcessStockHint: 'يزيل الكميات المنتهية من الدفعات، يحدّث المخزون، ويُنشئ سجلات المنتجات المنتهية.',
      expiredClearRecords: 'مسح السجلات',
      expiredClearRecordsTitle: 'مسح السجلات المحذوفة (للاختبار)',
      expiredReset: 'إعادة تعيين',
      expiredDeleteTitle: 'حذف',
      expiredDeleteSuccess: 'تم حذف المنتج المنتهي الصلاحية',
      expiredDeleteError: 'خطأ في حذف المنتج',
      expiredStatusRemoved: 'إزالة من المخزون',
      expiredStatusExpired: 'منتهي الصلاحية',
      balanceTypeCurrent: 'الحالي',
      balanceTypeYearly: 'سنوي',
      balanceCloseToday: 'إغلاق اليوم',
      balanceClosingHistory: 'سجل الإغلاقات',
      balancePeriodClosingHistory: 'الإغلاقات الدورية',
      balancePeriodReviewPendingTitle: 'المزامنة موقوفة',
      balancePeriodReviewPendingHint:
        'راجع الإغلاق الدوري قبل استئناف الرفع: {{periods}}',
      closingTableauTitle: 'إغلاق اليوم',
      closingTableauHint: 'الإجماليات مطابقة للوحة التحكم (خروج الصندوق / السيولة).',
      closingTableauStatusOpen: 'اليوم مفتوح',
      closingTableauStatusClosed: 'اليوم مغلق',
      closingTableauPrevious: 'الإغلاق السابق (التاريخ والوقت)',
      closingTableauCurrent: 'الإغلاق الحالي (التاريخ والوقت)',
      closingTableauNone: 'لا يوجد',
      closingTableauPendingNow: 'جارٍ — {{date}}',
      closingTableauColLabel: 'البيان',
      closingTableauColAmount: 'المبلغ',
      closingTableauRevenue: 'الإيرادات (المبيعات)',
      closingTableauPayments: 'مدفوعات الموردين',
      closingTableauExpenses: 'المصروفات (حصة الصندوق)',
      closingTableauOutgoing: 'إجمالي خروج الصندوق',
      closingTableauNet: 'صافي السيولة',
      closingTableauExpenseDetail: 'تفاصيل مصروفات اليوم',
      closingTableauColExpense: 'المصروف',
      closingTableauColRegister: 'الصندوق',
      closingTableauColAccrual: 'المبلغ الكلي',
      closingTableauExternal: 'خارج الصندوق',
      closingTableauNoExpenses: 'لا توجد مصروفات مسجلة اليوم.',
      balanceClosingSuccess: 'تم إغلاق اليوم بنجاح',
      balanceClosingAlreadyClosed: 'تم إغلاق هذا اليوم مسبقاً',
      balanceClosingFailed: 'فشل الإغلاق',
      balanceClosingConfirm: 'إغلاق اليوم الحالي؟',
      balanceClosingActiveSessionsWarning: 'تنبيه: {{count}} جلسة كاشير لا تزال نشطة.',
      balanceClosingSuccessWithWarnings: 'تم الإغلاق (مع تحذيرات — راجع السجل).',
      balanceClosingInProgress: 'جاري الإغلاق…',
      balanceResetTodayClosing: 'إلغاء إغلاق اليوم',
      balanceYearlyTitle: 'ملخص المحل السنوي {{year}}',
      balanceYearlyClosings: '{{count}} إغلاق يومي',
      balancePeriodBanner: 'فترة الملخص: {{from}} – {{to}}',
      balancePeriodAll: 'كل التواريخ',
      balanceExportColLabel: 'البيان',
      balanceExportColAmount: 'المبلغ',
      balanceAssetsTitle: 'الأصول',
      balanceLiabilitiesTitle: 'الخصوم',
      balanceEquityTitle: 'حقوق الملكية',
      balanceCurrentAssetsSection: 'الأصول المتداولة',
      balanceCash: 'النقد',
      balanceCashRegister: 'رصيد الصندوق (نقداً)',
      balanceOpeningCashRemaining: 'رأس مال البدء المتبقي (نقداً)',
      balanceBank: 'البنك / إلكتروني',
      balanceBankDetailHint: 'تفصيل حسب الوسيلة: Bankily، Sedad، Massrivi…',
      balanceFinancingOffBalanceTitle: 'التمويل (خارج رصيد الصندوق)',
      balanceFinancingOffBalanceHint: 'لا يخصم من الرصيد — تفصيل حسب طريقة الدفع.',
      balanceOpeningCapitalUsed: 'رأس مال البدء المستخدم',
      balanceExternalFinancingUsed: 'تمويل خارجي',
      balanceAccountsReceivable: 'ذمم العملاء (مبيعات آجلة)',
      balanceInventory: 'المخزون',
      balanceFixedAssetsSection: 'الأصول الثابتة (رأس المال النشط)',
      balanceProperty: 'العقارات',
      balanceEquipment: 'المعدات',
      balanceVehicles: 'المركبات',
      balanceOtherFixed: 'أخرى',
      balanceActiveCapital: 'رأس المال النشط',
      balanceTotalCurrentAssets: 'إجمالي الأصول المتداولة',
      balanceTotalAssets: 'إجمالي الأصول',
      balanceCurrentLiabilitiesSection: 'الخصوم المتداولة',
      balanceAccountsPayable: 'ديون الموردين (نحن مدينون)',
      balanceAcceptedEcartLosses: 'خسائر الفروقات (مقبولة)',
      balanceAcceptedEcartGains: 'أرباح الفروقات (مقبولة)',
      balanceExpirationLosses: 'الخسائر بسبب انتهاء الصلاحية',
      balanceLiabilitiesByPeriod: 'الاستحقاقات (إرشادي)',
      balanceCurrentQuarter: 'استحقاق ≤ نهاية الربع',
      balanceCurrentYearPeriod: 'استحقاق ≤ نهاية السنة',
      balanceLongTermLiabilitiesSection: 'الخصوم طويلة الأجل',
      balanceLoans: 'القروض',
      balanceMortgages: 'الرهون العقارية',
      balanceForeignCapital: 'رأس المال الأجنبي',
      balanceTotalLiabilities: 'إجمالي الخصوم',
      balanceTotalLiabilitiesAndEquity: 'إجمالي الخصوم + حقوق الملكية',
      balanceEquityCapital: 'رأس المال',
      balanceEditOpeningCapital: '← إعداد رأس مال البدء',
      balanceRetainedEarnings: 'الأرباح المحتجزة',
      balanceCurrentYearProfit: 'ربح السنة الحالية',
      balanceOwnCapital: 'رأس المال الخاص',
      balanceTotalEquity: 'إجمالي حقوق الملكية',
      balanceEquationLabel: 'معادلة الميزانية',
      balanceEquationHint: 'الأصول = الخصوم + حقوق الملكية',
      balanceStatusOk: '✅ الحساب متوازن',
      balanceStatusWarn: '⚠️ الحساب غير متوازن',
      balanceDifference: 'الفرق',
      balanceFinancialSummaryTitle: 'الملخص المالي',
      balanceTotalRevenue: 'إجمالي الإيرادات',
      balanceOperatingExpenses: 'مصروفات التشغيل',
      balanceNetProfit: 'صافي الربح',
      balanceLiquidCashLabel: 'رصيد النقد (التدفق)',
      balanceLiquidBankLabel: 'الرصيد الإلكتروني (التدفق)',
      balanceLiquidHint: 'رصيد النقد والبنك يطابق «تقرير المدفوعات» (الوارد − الصادر). المصروفات تُخصم من النقد والربح، وليس من الخصوم.',
      balancePaymentReportReference: 'راجع تقرير المدفوعات (لوحة المدير)',
      balanceDailyClosingHistory: 'سجل الإغلاقات اليومية',
      ecartBreakdownTitle: 'حساب المبلغ المتوقع',
      ecartBreakdownHint:
        'الافتتاح + المبيعات + تحصيل الديون − الصادر من الصندوق = المبلغ المتوقع.',
      ecartBreakdownInitial: 'رصيد افتتاح الجلسة',
      ecartBreakdownCashSales: '+ مبيعات نقداً',
      ecartBreakdownCashDebt: '+ تحصيل ديون (نقداً)',
      ecartBreakdownCashOutgoing: '− صادر نقداً (مصروفات + مشتريات)',
      ecartBreakdownExpectedCash: '= المبلغ المتوقع (نقداً)',
      ecartBreakdownCashSection: 'نقداً',
      ecartBreakdownInitialElectronic: 'الرصيد الإلكتروني الافتتاحي',
      ecartBreakdownElectronicSales: '+ مبيعات إلكترونية',
      ecartBreakdownElectronicDebt: '+ تحصيل ديون (إلكتروني)',
      ecartBreakdownElectronicOutgoing: '− صادر إلكتروني',
      ecartBreakdownExpectedElectronic: '= المبلغ الإلكتروني المتوقع',
      ecartBreakdownElectronicSection: 'إلكتروني',
      paymentReportBalanceHint: 'هذه الأرصدة تطابق «النقد» و«البنك» في ملخص المحل (التقارير → ملخص المحل).',
      balanceDeleteConfirmTitle: 'تأكيد الحذف',
      balanceDeleteConfirmMessage: 'هل أنت متأكد من حذف المنتج المنتهي الصلاحية « {{product}} »؟ لا يمكن التراجع عن هذا الإجراء.'
    },

    // Packaging
    packagingType: 'نوع التعبئة',
    unitary: 'وحدات منفصلة',
    package: 'كرتونة',
    productsPerPackage: 'عدد المنتجات في الكرتونة',
    numberOfPackages: 'عدد الكراتين',
    totalQuantity: 'إجمالي الكمية',
    packagePrice: 'سعر الكرتونة',
    unitPrice: 'سعر الوحدة',
    sellingPrice: 'سعر البيع',

    // Messages
    noDataFound: 'لا توجد بيانات',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'تم بنجاح',
    warning: 'تحذير',
    info: 'معلومات',
    confirmDelete: 'هل أنت متأكد من حذف هذا العنصر؟',
    dataSaved: 'تم حفظ البيانات بنجاح',
    dataDeleted: 'تم حذف البيانات بنجاح',
    dataUpdated: 'تم تحديث البيانات بنجاح',
    isRequired: 'مطلوب',
    mustBeValid: 'يجب أن يكون صالحاً',
    optional: 'اختياري',
    relatedTo: 'متعلق بـ',
    none: 'لا شيء',
    all: 'الكل',

    // Dashboard
    totalProducts: 'إجمالي المنتجات',
    totalCustomers: 'إجمالي العملاء',
    totalSuppliers: 'إجمالي الموردين',
    totalSales: 'إجمالي المبيعات',
    totalPurchases: 'إجمالي المشتريات',
    monthlyRevenue: 'الإيرادات الشهرية',
    monthlyProfit: 'الربح الشهري',
    recentActivities: 'الأنشطة الأخيرة',
    inventoryAlerts: 'تنبيهات المخزون',
    quickActions: 'الإجراءات السريعة',

    // Inventory
    addProduct: 'إضافة منتج',
    editProduct: 'تعديل منتج',
    productName: 'اسم المنتج',
    currentStock: 'المخزون الحالي',
    lowStock: 'مخزون منخفض',
    outOfStock: 'نفد من المخزون',
    inStock: 'متوفر في المخزون',
    stock: 'المخزون',

    // Sales
    addSale: 'إضافة عملية بيع',
    editSale: 'تعديل عملية بيع',
    saleDate: 'تاريخ البيع',
    customerName: 'اسم العميل',
    saleTotal: 'إجمالي البيع',
    paymentMethod: 'طريقة الدفع',
    cash: 'نقداً',
    card: 'بطاقة',
    transfer: 'تحويل',

    // Payment Management
    paymentManagement: 'دفع الفواتير',
    managePayments: 'دفع الفواتير',
    manageSupplierInvoices: 'إدارة فواتير الموردين والمدفوعات',
    paymentManagementReport: 'تقرير إدارة المدفوعات',
    invoiceId: 'رقم الفاتورة',
    invoiceNumber: 'رقم الفاتورة',
    notAvailable: 'غير متوفر',
    pending: 'قيد الانتظار',
    dueDate: 'تاريخ الاستحقاق',
    totalInvoices: 'إجمالي الفواتير',
    pendingPayments: 'المدفوعات المعلقة',
    paidInvoices: 'الفواتير المدفوعة',
    totalAmount: 'المبلغ الإجمالي',
    paidAmount: 'المبلغ المدفوع',
    remainingAmount: 'المبلغ المتبقي',
    partialInvoices: 'الفواتير المدفوعة جزئياً',
    pendingInvoices: 'الفواتير المعلقة',
    openInvoices: 'الفواتير المفتوحة',
    noOpenInvoices: 'لا توجد فواتير مفتوحة',
    allInvoicesPaid: 'تم دفع جميع الفواتير',
    paidStatus: 'مدفوع',
    partialStatus: 'مدفوع جزئياً',
    pendingStatus: 'قيد الانتظار',
    newInvoicesCreated: 'تم إنشاء فواتير جديدة',
    noNewInvoices: 'لا توجد فواتير جديدة لإنشائها',
    errorCreatingInvoices: 'حدث خطأ أثناء إنشاء الفواتير',
    confirmDeleteAll: 'هل أنت متأكد من حذف جميع الفواتير؟',
    invoiceManagement: 'إدارة الفواتير',
    createInvoicesFromPurchases: 'إنشاء الفواتير من المشتريات',
    deleteAllInvoices: 'حذف جميع الفواتير',
    allInvoices: 'جميع الفواتير',
    invoiceValue: 'قيمة الفواتير',
    paid: 'مدفوع',
    toPay: 'مستحق الدفع',
    complete: 'مكتمل',
    partiallyPaid: 'مدفوع جزئياً',
    unpaid: 'غير مدفوع',
    withDebt: 'مع دين',
    recentInvoices: 'الفواتير الأخيرة',
    noInvoices: 'لا توجد فواتير',

    // Accounts Receivable = ventes à crédit (le client nous doit)
    accountsReceivable: 'ذمم العملاء',
    customerDebts: 'ذمم العملاء (مبيعات آجلة)',
    customerInvoices: 'فواتير العملاء',
    customerCredit: 'ائتمان العميل',
    creditLimit: 'حد الائتمان',
    creditUsed: 'الائتمان المستخدم',
    creditAvailable: 'الائتمان المتاح',
    customerInvoice: 'فاتورة العميل',
    createCustomerInvoice: 'إنشاء فاتورة عميل',
    customerPayment: 'دفعة العميل',
    addCustomerPayment: 'إضافة دفعة عميل',
    totalCustomerDebt: 'إجمالي ذمم العملاء',
    remainingCustomerDebt: 'الذمة المتبقية للعميل',
    customerCreditLimit: 'حد ائتمان العميل',
    creditExceeded: 'تم تجاوز حد الائتمان',
    creditWarning: 'تحذير: قريب من حد الائتمان',

    // Expenses
    expenses: 'المصروفات',
    expense: 'مصروف',
    addExpense: 'إضافة مصروف',
    editExpense: 'تعديل مصروف',
    expenseCategory: 'فئة المصروف',
    expenseCategories: {
      rent: 'الإيجار',
      utilities: 'المرافق العامة',
      salaries: 'الرواتب',
      marketing: 'التسويق',
      maintenance: 'الصيانة',
      office: 'المكتب',
      travel: 'السفر',
      taxes: 'الضرائب',
      interest: 'الفائدة',
      customs: 'الجمارك',
      transport: 'النقل',
      shipping: 'الشحن',
      other: 'أخرى'
    },
    totalExpenses: 'إجمالي المصروفات',
    expenseDate: 'تاريخ المصروف',
    expenseDescription: 'وصف المصروف',
    expenseReceipt: 'إيصال المصروف',
    monthlyExpenses: 'المصروفات الشهرية',
    expenseReport: 'تقرير المصروفات',
    allExpenses: 'جميع المصروفات',
    customs: 'الجمارك',
    transport: 'النقل',
    isRequired: 'مطلوب',
    mustBeValid: 'يجب أن يكون صالحاً',
    optional: 'اختياري',
    relatedTo: 'متعلق بـ',
    none: 'لا شيء',
    customPeriod: 'فترة مخصصة',
    lastWeek: 'الأسبوع الماضي',
    lastMonth: 'الشهر الماضي',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    accessDenied: 'تم رفض الوصول',
    noPermission: 'ليس لديك صلاحية للوصول إلى هذه الصفحة',
    paymentMethod: 'طريقة الدفع',
    cash: 'نقد',
    bankTransfer: 'تحويل بنكي',
    check: 'شيك',
    mobileMoney: 'المال المحمول',
    today: 'اليوم',
    quickSaleCashRegister: 'كاشير البيع السريع',
    currentBalance: 'الرصيد الحالي',
    sessionCashExpected: 'المبلغ المتوقع (الجلسة النشطة)',

    // Error Messages
    validationError: 'خطأ في التحقق من البيانات',
    stockError: 'خطأ في المخزون',
    insufficientStock: 'المخزون المتاح غير كافٍ',
    productNotAvailable: 'المنتج غير متوفر في المخزون',
    error: 'خطأ',
    cannotSaveEmptyDraft: 'لا يمكن حفظ مسودة فارغة',
    saved: 'تم الحفظ',
    draftSavedSuccess: 'تم حفظ المسودة بنجاح',
    invalidDraft: 'المسودة غير صالحة',
    loaded: 'تم التحميل',
    draftLoadedSuccess: 'تم تحميل المسودة بنجاح',
    deleted: 'تم الحذف',
    draftDeletedSuccess: 'تم حذف المسودة بنجاح',
    allDraftsDeleted: 'تم حذف جميع المسودات',
    allDraftsDeletedSuccess: 'تم حذف جميع المسودات بنجاح',
    emptyCart: 'السلة فارغة',
    addProductsBeforeSale: 'أضف منتجات قبل إتمام البيع',
    amountError: 'خطأ في المبلغ',
    insufficientAmount: 'المبلغ غير كافٍ',
    preparationError: 'خطأ في التحضير',
    cannotPrepareSale: 'تعذر إعداد بيانات البيع',
    saleConfirmedSuccess: 'تم تأكيد البيع بنجاح',
    saleSavedSuccess: 'تم حفظ البيع بنجاح',
    validationErrorTitle: 'خطأ في التحقق',
    stockErrorTitle: 'خطأ في المخزون',
    paymentError: 'خطأ في الدفع',
    cartCleared: 'تم مسح السلة',
    
    // UI Labels
    searchPlaceholder: 'بحث بالاسم أو SKU أو الباركود…',
    stockLabel: 'المخزون:',
    saleDrafts: 'مسودات المبيعات',
    drafts: 'مسودات',
    scanBarcode: 'مسح الباركود',
    scan: 'مسح',
    fullscreen: 'ملء الشاشة',
    
    // Legacy compatibility
    locations: {
      'Principal': 'المخزون الرئيسي',
      'Secondaire': 'المخزون الثانوي',
      'Other': 'أخرى',
      'Entrepôt': 'المستودع',
      'Boutique': 'المتجر',
      'Magasin': 'المحل'
    },

    posPage: {
      cart: 'السلة',
      clearCart: 'مسح',
      clearCartTitle: 'مسح السلة',
      decrease: 'إنقاص',
      increase: 'زيادة',
      editPrice: 'تعديل السعر',
      editPackPrice: 'تعديل سعر الكرتون',
      packLineTag: '{{packs}} كرتون × {{units}} وحدة',
      packQtyBaseUnits: 'الكمية بالكراتين (المخزون = وحدات)',
      checkoutSteps: 'خطوات الدفع',
      stepCart: 'السلة',
      stepPayment: 'الدفع',
      stepReceipt: 'الإيصال',
      linesLabel: 'السطور',
      qtyShort: 'الكمية',
      cartColQty: 'الكمية',
      cartColUnitPrice: 'سعر الوحدة',
      cartColSubtotal: 'المجموع',
      payment: 'الدفع',
      electronic: 'إلكتروني',
      credit: 'آجل',
      creditHint: 'بيع آجل — العميل على الإيصال (اختيار / إنشاء). الباقي لا يدخل الصندوق.',
      creditDeposit: 'دفعة الآن',
      creditDepositMethod: 'طريقة الدفعة',
      creditRemainder: 'المتبقي آجل',
      creditCustomer: 'العميل',
      creditCustomerPlaceholder: 'الاسم أو الهاتف…',
      debtOwed: 'دين مفتوح',
      debtCollect: 'تحصيل',
      paymentKeyCash: 'F2',
      paymentKeyElectronic: 'F3',
      paymentKeyCredit: 'F5',
      paymentShortcutCashHint: 'F2 / Ctrl+2',
      paymentShortcutElectronicHint: 'F3 / Ctrl+3',
      paymentShortcutCreditHint: 'F5 / Ctrl+4',
      amountPaid: 'المبلغ المدفوع',
      exactAmount: 'مطابق',
      totalToPay: 'الإجمالي',
      change: 'الباقي',
      draft: 'مسودة',
      deliveryMode: 'وضع التوصيل',
      deliveryHint:
        'يرسل إلى المطبخ (عمود التوصيل) ويحفظ مسودة للتحصيل عند التوصيل.',
      deliveryPhone: 'الهاتف (اختياري)',
      deliveryPhonePlaceholder: 'مثال 22 12 34 56',
      deliverySave: 'إنشاء توصيل',
      processing: 'جاري المعالجة...',
      checkoutLoading: 'جاري التحميل...',
      checkout: 'إتمام البيع',
      enterKey: 'Enter',
      searchFocusHint: 'Ctrl+F / F4',
      searchFocusKey: 'Ctrl+F',
      loadingProducts: 'جاري تحميل المنتجات...',
      noProductsAvailable: 'لا توجد منتجات متاحة',
      emptyGridHint: 'غيّر الفئة أو ابحث عن منتج / باركود.',
      emptyGridCta: 'فتح البحث',
      emptyCartHint: 'امسح باركوداً أو ابحث عن منتج للبدء.',
      emptyCartCta: 'البحث عن منتج',
      outOfStockShort: 'نفد المخزون',
      addPurchase: 'إضافة شراء',
      stockLabel: 'المخزون',
      draftsTitle: 'مسودات المبيعات',
      drafts: 'مسودات',
      scanBarcode: 'مسح الباركود',
      scan: 'مسح',
      menuSectionsAria: 'أقسام القائمة',
      posCategoriesAria: 'فئات نقطة البيع',
      posToolsAria: 'أدوات الصندوق',
      importExcel: 'استيراد Excel',
      serviceModeEmporter: 'للأخذ',
      serviceModeService: 'خدمة',
      tableFloorTitle: 'الطاولات',
      tableFloorHint: 'اختر طاولة لفتح أو متابعة طلب.',
      tableFloorEmpty: 'لا طاولات نشطة — أضف طاولات من الإعدادات.',
      tableFree: 'فارغة',
      tableOccupied: 'مشغولة',
      tableActiveBadge: 'طاولة {{label}}',
      tableSaveTicket: 'حفظ',
      tableBackToFloor: 'الطاولات',
      tableCancelTicket: 'إلغاء التذكرة',
      coversLabel: 'عدد الأشخاص',
      coversShort: '{{count}} أشخاص',
      courseLabel: 'الوجبة',
      course_entree: 'مقبلات',
      course_plat: 'طبق',
      course_dessert: 'حلوى',
      course_boisson: 'مشروب',
      course_autre: 'أخرى',
      kitchenSend: 'إرسال للمطبخ',
      kitchenMarkReady: 'جاهز',
      kitchenMarkServed: 'تم التقديم',
      kitchenStatus_sent: 'في المطبخ',
      kitchenStatus_preparing: 'تحضير',
      kitchenStatus_ready: 'جاهز',
      kitchenStatus_served: 'تم التقديم',
      kitchenSent: 'المطبخ',
      kitchenSentSuccess: 'تم إرسال {{count}} بند',
      kitchenSentParked: 'تم إرسال {{count}} بند — السلة فارغة، بانتظار المطبخ',
      kitchenSentAjout: 'إضافة للمطبخ',
      kitchenSentAjoutDetail: 'إضافة: {{count}} بند جديد فقط — وليس الطلب كاملاً',
      kitchenSendFailed: 'تعذر الإرسال للمطبخ — أعد المحاولة',
      kitchenNothingToSend: 'المطبخ',
      kitchenNothingToSendDetail: 'لا جديد لإرساله',
      kitchenParkedAwaiting: 'الطلب في المطبخ — يمكن التحصيل (جاهز اختياري)',
      kitchenParkedPayable: 'المطبخ: يمكن التحصيل',
      kitchenLoadForPay: 'تحميل للتحصيل',
      kitchenCheckoutAwaiting: 'في المطبخ…',
      kitchenCheckoutSendFirst: 'إرسال للمطبخ',
      kitchenOrders: 'المطبخ',
      kitchenOrdersTitle: 'طلبات المطبخ',
      kitchenOrdersHint:
        'الطلبات المرسلة — حمّل إلى السلة فقط عند التحصيل. الطاولة وللأخذ والتوصيل منفصلون.',
      kitchenOrdersOpen: 'فتح الطلبات',
      kitchenOrdersEmpty: 'لا طلبات مطبخ',
      kitchenOrdersSectionTable: 'في المكان (طاولات)',
      kitchenOrdersSectionEmporter: 'للأخذ',
      kitchenOrdersSectionDelivery: 'توصيل',
      kitchenOrdersSectionEmpty: 'لا شيء هنا',
      kitchenSoundOn: 'صوت',
      kitchenSoundOff: 'صامت',
      kitchenSoundMute: 'كتم أصوات المطبخ',
      kitchenSoundUnmute: 'تفعيل أصوات المطبخ',
      kitchenReleaseSecondScreen: 'مشاركة الشاشة الثانية',
      kitchenReleaseSecondScreenTitle:
        'عرض المطبخ فقط على الشاشة الثانية (HDMI / لاسلكي) — وليس سطح المكتب كله',
      kitchenOrderChannelTable: 'طاولة',
      kitchenOrderChannelEmporter: 'للأخذ',
      kitchenOrderChannelDelivery: 'توصيل',
      kitchenOrderTableTitle: 'طاولة {{label}}',
      kitchenOrderEmporterTitle: 'للأخذ',
      kitchenOrderDeliveryTitle: 'توصيل',
      kitchenOrderDeliveryTitlePhone: 'توصيل · {{phone}}'
    },

    authPage: {
      ...authPageLoginAr,
      back: 'رجوع',
      backToLogin: 'العودة إلى تسجيل الدخول',
      forgotPasswordTitle: 'نسيت كلمة المرور',
      forgotPasswordSubtitleOffline: 'أعد تعيين كلمة المرور بدون إنترنت — برمز المدير أو NIF.',
      forgotPasswordSubtitle: 'أعد تعيين كلمة المرور بدون إنترنت — برمز المدير أو NIF.',
      forgotPasswordHeading: 'إعادة التعيين بدون اتصال',
      forgotStepIdentify: '1. المعرّف',
      forgotStepVerify: '2. التحقق',
      forgotStepReset: '3. كلمة مرور جديدة',
      forgotContinue: 'متابعة',
      forgotOfflineInfo: 'يعمل بدون إنترنت. تُحفظ البيانات في localStorage على هذا الجهاز.',
      forgotAccountFound: 'الحساب: {{name}}',
      identifierLabel: 'اسم المستخدم أو البريد',
      identifierPlaceholder: 'المعرّف المستخدم عند التسجيل',
      verificationCodeLabel: 'رمز المدير أو NIF',
      verificationCodePlaceholder: 'الرمز المحدد عند التسجيل',
      verificationCodeHint: 'أدخل رمز المدير (4 أرقام) أو NIF المسجل عند إنشاء الحساب.',
      verificationCodeRequired: 'رمز المدير أو NIF مطلوب',
      invalidVerificationCode: 'رمز المدير أو NIF غير صحيح',
      accountNotFoundOffline: 'لا يوجد حساب محلي بهذا المعرّف',
      offlineResetSuccessNote: 'تم حفظ كلمة المرور محلياً (localStorage + IndexedDB).',
      emailLabel: 'البريد الإلكتروني',
      emailPlaceholder: 'أدخل بريدك الإلكتروني',
      sendResetLink: 'إرسال رابط إعادة التعيين',
      resetLinkInfo: 'سيتم إرسال رابط إعادة التعيين إلى بريدك الإلكتروني.',
      resetLinkInfo2: 'انقر على الرابط في البريد لإنشاء كلمة مرور جديدة.',
      emailSentTitle: 'تم إرسال البريد',
      emailSentMessage: 'تم إرسال رابط إعادة التعيين إلى بريدك الإلكتروني.',
      emailSentCheck: 'تحقق من صندوق الوارد وانقر على الرابط لإعادة تعيين كلمة المرور.',
      accountNotFound: 'لا يوجد حساب بهذا البريد الإلكتروني',
      genericError: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
      passwordResetTitle: 'إعادة تعيين كلمة المرور',
      resetPasswordTitle: 'كلمة مرور جديدة',
      resetPasswordSubtitle: 'اختر كلمة مرور آمنة لـ {{email}}',
      resetPasswordHeading: 'إعادة التعيين',
      newPasswordLabel: 'كلمة المرور الجديدة',
      newPasswordPlaceholder: 'أدخل كلمة المرور الجديدة',
      confirmPasswordLabel: 'تأكيد كلمة المرور',
      confirmPasswordPlaceholder: 'أكد كلمة المرور',
      savePassword: 'حفظ كلمة المرور',
      passwordUpdatedTitle: 'تم تحديث كلمة المرور',
      passwordUpdatedMessage: 'يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.',
      invalidResetLink: 'رابط إعادة التعيين غير صالح.',
      invalidOrExpiredLink: 'رابط إعادة التعيين غير صالح أو منتهي الصلاحية',
      linkExpired: 'انتهت صلاحية هذا الرابط. اطلب رابطاً جديداً.',
      passwordMinLength: 'يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل',
      passwordMismatch: 'كلمتا المرور غير متطابقتين',
      updatePasswordFailed: 'تعذر تحديث كلمة المرور',
      resetLinkSentTo: 'تم إرسال رابط إعادة التعيين إلى {{email}}:\n{{link}}'
    },

    printerPicker: {
      title: 'اختيار الطابعة',
      currentPrinter: 'الطابعة الحالية',
      loading: 'جاري التحميل...',
      loadError: 'تعذر تحميل الطابعات',
      noPrinters: 'لم يتم اكتشاف أي طابعة. تأكد من تشغيل Electron.',
      cancel: 'إلغاء',
      confirm: 'تأكيد'
    },

    paginationPage: {
      previous: 'السابق',
      next: 'التالي',
      pageOf: 'صفحة {{current}} من {{total}}',
      showing: 'عرض {{start}} إلى {{end}} من {{total}} نتيجة',
      showLabel: 'عرض :',
      firstPage: 'الصفحة الأولى',
      previousPage: 'الصفحة السابقة',
      nextPage: 'الصفحة التالية',
      lastPage: 'الصفحة الأخيرة'
    },

    managerDashboard: managerDashboardAr,
    workerSessionManager: workerSessionManagerAr,
    paymentReportPage: paymentReportPageAr,
    stockPage: stockPageAr,
    catalogPage: catalogPageAr,
    settingsPage: settingsPageAr,
    employeesPage: employeesPageAr,
    inventoryPage: inventoryPageAr,
    priceLabels: priceLabelsAr,
    addProductModal: addProductModalAr,
    addOrderModal: addOrderModalAr,
    addPurchaseModal: addPurchaseModalAr,
    editProductModal: editProductModalAr,
    orderConfirmationModal: orderConfirmationModalAr,
    achatVsVenteReport: achatVsVenteReportAr,
    foodCostReport: foodCostReportAr,
    adminDashboard: adminDashboardAr,
    registerPage: registerPageAr,
    productValidationModal: productValidationModalAr,
    codeEntryModal: codeEntryModalAr,
    salesDetailsModal: salesDetailsModalAr,
    editOrderModal: editOrderModalAr,
    dashboardReceiptModal: dashboardReceiptModalAr,
    ordersExcelImportModal: ordersExcelImportModalAr,
    posDashboard: posDashboardAr,
    smartInvoiceDisplay: smartInvoiceDisplayAr,
    lotSelectionModal: lotSelectionModalAr,
    editPurchaseModal: editPurchaseModalAr,
    layoutShell: layoutShellAr,
    addCustomerModal: addCustomerModalAr,
    draftsModal: draftsModalAr,
    fastImportModal: fastImportModalAr,
    addSupplierModal: addSupplierModalAr,
    datePicker: datePickerAr,
    excelImportModal: excelImportModalAr,
    paymentManagementPage: paymentManagementPageAr,
    orderDetailsModal: orderDetailsModalAr,
    exportPrintButton: exportPrintButtonAr,
    virtualizedProductRow: virtualizedProductRowAr,
    merchantReceiptModal: merchantReceiptModalAr,
    confirmDialog: confirmDialogAr,
    ecartModal: ecartModalAr,
    dailyClosingHistoryModal: dailyClosingHistoryModalAr,
    periodClosingHistoryModal: periodClosingHistoryModalAr,
    loadingOverlay: loadingOverlayAr,
    notificationCenter: notificationCenterAr,
    newCashRegisterModal: newCashRegisterModalAr,
    workerDashboardModal: workerDashboardModalAr,
    excelImportAchatModal: excelImportAchatModalAr,
    barcodeScanner: barcodeScannerAr,
    languageSwitcher: languageSwitcherAr,
    offlineIndicator: offlineIndicatorAr,
    storageSafeModeBanner: storageSafeModeBannerAr,
    inventoryLedgerSafeMode: inventoryLedgerSafeModeAr,
    conditionalRoutes: conditionalRoutesAr,
    storageBootstrap: storageBootstrapAr,
    tableCommon: tableCommonAr,
    pharmacyLotManager: pharmacyLotManagerAr,
    printServicePage: printServicePageAr,
    barcodeAutoLinkModal: barcodeAutoLinkModalAr,
    restaurantPage: restaurantPageAr,
    cuisinePage: cuisinePageAr,
    pharmacyDashboard: pharmacyDashboardAr,
    paymentModal: paymentModalAr,
    invoiceManagementModal: invoiceManagementModalAr
  }
};

/**
 * Get translation by key with dot notation support
 * @param {string} key - Translation key (supports dot notation like 'dashboard.title')
 * @param {string} language - Language code ('fr' or 'ar')
 * @returns {string} Translated text or key if not found
 */
export const getTranslation = (key, language = 'fr') => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && value[k] !== undefined) {
      value = value[k];
    } else {
      return key; // Return the key if translation not found
    }
  }
  
  return value;
};